<template>
  <div>
    <!-- Navigation -->
    <v-bottom-navigation color="info" horizontal :background-color="color" dark>
      <v-btn to="/college/personnel_etc" large class="mr-10">
        <span class="bottom-navi">ข้อมูลบุคคลสถานศึกษา</span>
        <v-icon>mdi-account-multiple</v-icon>
      </v-btn>
      <v-btn to="/college/rate_workforce_g" large class="mr-10">
        <span class="bottom-navi">งานอัตราสถานศึกษา</span>
        <v-icon>mdi-numeric-1-box</v-icon>
      </v-btn>
    </v-bottom-navigation>

    <v-container fluid>
      <base-material-card
        icon="mdi-clipboard-text"
        title="ข้อมูล ข้าราชการ ลูกจ้างประจำ พนักงานราชการ ครูอัตราจ้างหรือลูกจ้างชั่วคราว"
        class="px-5 py-3"
      >
        <!-- ปุ่มวิดีโอแนะนำ -->
        <div class="text-right">
          <v-btn
            text
            color="red"
            @click="VideoDialogYoutubeConditionbranch = true"
          >
            <v-icon large color="red">mdi-video</v-icon>
          </v-btn>
        </div>

        <div>
          <Personnel_report />
        </div>

        <!-- ข้อความแจ้งเตือน -->
        <v-card class="pa-1 mb-3">
          <v-alert type="info" outlined>
            <h3>
              ข้อมูลบุคคลสถานศึกษาในส่วนนี้ เกี่ยวข้องกับระบบ ID Plan
              ให้ปรับปรุงให้เป็นปัจจุบัน โดยระบบจะส่งข้อมูลไปยังระบบ ID Plan
              ทุกวันในเวลาเที่ยงคืน
            </h3>
            <div>
              สถานศึกษาสามารถลบบุคคลที่ไม่ได้เกี่ยวข้องกับสถานศึกษาออกจากระบบได้ให้เป็นปัจจุบัน
            </div>
          </v-alert>
        </v-card>

        <!-- ============================================= -->
        <!-- แจ้งเตือนรอบรายงานชั่วโมงสอน (ใหม่)            -->
        <!-- ============================================= -->
        <v-card
          v-if="activeRound && activeRound.round_id"
          class="pa-3 mb-3"
          outlined
          :color="activeRoundAlertColor"
        >
          <v-card-title class="pb-1">
            <v-icon left :color="activeRoundAlertColor">mdi-bell-ring</v-icon>
            <span class="font-weight-bold">แจ้งเตือนรอบรายงานชั่วโมงสอน</span>
          </v-card-title>
          <v-card-text>
            <v-alert
              :type="activeRoundAlertType"
              prominent
              outlined
              class="mb-2"
            >
              <h3>
                {{ activeRound.round_name }} — สถานะ:
                <v-chip
                  small
                  :color="
                    activeRound.round_status === 'open' ? 'green' : 'grey'
                  "
                  dark
                >
                  {{
                    activeRound.round_status === "open"
                      ? "เปิดรับรายงาน"
                      : activeRound.round_status
                  }}
                </v-chip>
              </h3>
              <div class="mt-2">
                <strong>ช่วงเวลารับรายงาน:</strong>
                {{ activeRound.round_start_date }} ถึง
                {{ activeRound.round_end_date }}
              </div>
              <div class="mt-1" v-if="activeRoundTeachSemester">
                <v-icon small color="orange">mdi-alert-circle</v-icon>
                <strong class="orange--text">
                  กรุณารายงานชั่วโมงสอน: {{ activeRoundTeachSemesterLabel }}
                </strong>
              </div>
              <div class="mt-1">
                <span
                  class="red--text font-weight-bold"
                  v-if="teachHoursMissingCount > 0"
                >
                  <v-icon small color="red">mdi-alert</v-icon>
                  พบบุคลากรสายการสอนที่ยังไม่ได้กรอกชั่วโมงสอน{{
                    activeRoundTeachSemesterLabel
                  }}
                  จำนวน {{ teachHoursMissingCount }} คน
                </span>
                <span class="green--text font-weight-bold" v-else>
                  <v-icon small color="green">mdi-check-circle</v-icon>
                  บุคลากรสายการสอนกรอกชั่วโมงสอนครบถ้วนแล้ว
                </span>
              </div>
            </v-alert>
          </v-card-text>
        </v-card>

        <!-- ============================================= -->
        <!-- แจ้งเตือนปีหลักสูตรไม่เป็นปัจจุบัน (ใหม่)       -->
        <!-- ============================================= -->
        <v-card
          v-if="outdatedCourseYearPersonnel.length > 0"
          class="pa-3 mb-3"
          outlined
        >
          <v-card-title class="pb-1">
            <v-icon left color="red">mdi-alert-octagon</v-icon>
            <span class="font-weight-bold red--text">
              แจ้งเตือน: ปีหลักสูตรไม่เป็นปัจจุบัน (ต่ำกว่า 2567)
            </span>
          </v-card-title>
          <v-card-text>
            <v-alert type="error" outlined prominent class="mb-2">
              <div>
                พบบุคลากรสายการสอนที่มีปีหลักสูตรต่ำกว่า 2567 จำนวน
                <strong>{{ outdatedCourseYearPersonnel.length }}</strong> คน
                กรุณาปรับปรุงข้อมูลสาขาวิชาให้เป็นหลักสูตรปี 2567 เป็นต้นไป
              </div>
              <div class="mt-2">
                <strong>รายชื่อ:</strong>
              </div>
              <v-chip
                v-for="(p, idx) in outdatedCourseYearPersonnel.slice(0, 10)"
                :key="idx"
                small
                color="red"
                dark
                class="mr-1 mb-1"
              >
                {{ p.personnel_etc_title }}{{ p.personnel_etc_fristname }}
                {{ p.personnel_etc_lastname }}
                (ปีหลักสูตร: {{ p.year_course || "ไม่ระบุ" }})
              </v-chip>
              <div
                v-if="outdatedCourseYearPersonnel.length > 10"
                class="mt-1 grey--text"
              >
                ...และอีก {{ outdatedCourseYearPersonnel.length - 10 }} คน
              </div>
            </v-alert>
          </v-card-text>
        </v-card>

        <!-- ============================================= -->
        <!-- สถิติภาพรวม - Dashboard สถิติสำคัญ              -->
        <!-- ============================================= -->
        <v-card class="pa-3 mb-3" outlined>
          <v-card-title class="pb-1">
            <v-icon left color="primary">mdi-chart-bar</v-icon>
            <span class="font-weight-bold">สถิติภาพรวมบุคลากร</span>
          </v-card-title>

          <!-- Row 1: จำนวนตามประเภท -->
          <v-row class="px-3">
            <v-col
              cols="12"
              sm="6"
              md="3"
              v-for="(stat, idx) in statCards"
              :key="idx"
            >
              <v-card
                :color="stat.color"
                dark
                class="pa-3 text-center stat-card-animated"
                style="border-radius:12px"
              >
                <v-icon size="28">{{ stat.icon }}</v-icon>
                <div class="text-h5 font-weight-bold mt-1">
                  {{ stat.count }}
                </div>
                <div class="caption">{{ stat.label }}</div>
              </v-card>
            </v-col>
          </v-row>

          <!-- Row 2: สถิติชั่วโมงสอน & งาน -->
          <v-row class="px-3 mt-2">
            <v-col cols="12" md="4">
              <v-card outlined class="pa-3 text-center">
                <v-icon color="orange" size="28">mdi-clock-outline</v-icon>
                <div class="text-h5 font-weight-bold mt-1">
                  {{ teachingHoursStats.avgS1 || 0 }} /
                  {{ teachingHoursStats.avgS2 || 0 }}
                </div>
                <div class="caption">ชม.สอนเฉลี่ย/สัปดาห์ (ภ.1 / ภ.2)</div>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card outlined class="pa-3 text-center">
                <v-icon color="green" size="28">mdi-school</v-icon>
                <div class="text-h5 font-weight-bold mt-1">
                  {{ teachingHoursStats.totalTeachers || 0 }}
                </div>
                <div class="caption">สายการสอนทั้งหมด</div>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card outlined class="pa-3 text-center">
                <v-icon color="purple" size="28">mdi-account-group</v-icon>
                <div class="text-h5 font-weight-bold mt-1">
                  {{ helpingCount }}
                </div>
                <div class="caption">ช่วยราชการ</div>
              </v-card>
            </v-col>
          </v-row>
        </v-card>

        <!-- คำแนะนำการใช้งาน (ซ่อนได้) -->
        <v-expansion-panels flat class="mb-3">
          <v-expansion-panel>
            <v-expansion-panel-header>
              <span class="font-weight-bold">
                <v-icon left>mdi-help-circle-outline</v-icon>คำแนะนำการใช้งาน
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div style="text-indent:2em;">
                1.
                <span class="red--text font-weight-bold">
                  ค้นหาบุคคลจากฐานข้อมูลงานอัตรากำลังของสถานศึกษาอื่น ๆ ในระบบ
                </span>
                หากไม่ปรากฎให้ดำเนินการยังปุ่ม
                <span class="font-weight-bold"
                  >เพิ่มบุคลากร/ค้นหาข้าราชการจากระบบหลัก</span
                >
              </div>
              <div style="text-indent:2em;">
                2.กรณี <span class="red--text font-weight-bold">ข้าราชการ</span>
                ให้ดำเนินการยังปุ่ม
                <span class="font-weight-bold"
                  >เพิ่มบุคลากร/ค้นหาข้าราชการจากระบบหลัก</span
                >
                และไปยังเครื่องมือค้นหา โดยค้นหาจากหมายเลขบัตรประชาชน
              </div>
              <div style="text-indent:2em;">
                3.กรณี
                <span class="red--text font-weight-bold"
                  >ลูกจ้างประจำ พนักงานราชการ ลูกจ้างชั่วคราว</span
                >
                ให้ดำเนินการยังปุ่ม
                <span class="font-weight-bold"
                  >เพิ่มบุคลากร/ค้นหาข้าราชการจากระบบหลัก</span
                >
                โดยกรอกข้อมูลเพิ่มบุคลากร สามารถทำได้ 2 วิธี คือ 1)
                กรอกเพิ่มที่ละรายบุคคล หรือ 2) นำเข้าข้อมูลเบื้องต้นผ่านไฟล์
                .CSV
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- สรุปจำนวนบุคลากร + ปุ่มเพิ่ม -->
        <v-card class="pa-2 mb-3">
          <v-row no-gutters>
            <v-col cols="12" md="8" class="pa-1">
              <v-simple-table class="elevation-1">
                <thead style="background-color: wheat;">
                  <tr>
                    <th class="text-left font-weight-bold">ประเภท</th>
                    <th class="text-left font-weight-bold">จำนวน (คน)</th>
                    <th class="text-left font-weight-bold">ประเภท</th>
                    <th class="text-left font-weight-bold">จำนวน (คน)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>ผู้อำนวยการ</td>
                    <td>{{ personnel_etcsCounts.directors }}</td>
                    <td>รองผู้อำนวยการ</td>
                    <td>{{ personnel_etcsCounts.se_directors }}</td>
                  </tr>
                  <tr>
                    <td>ข้าราชการครู</td>
                    <td>{{ personnel_etcsCounts.teachers }}</td>
                    <td>ศึกษานิเทศก์</td>
                    <td>{{ personnel_etcsCounts.supervisions }}</td>
                  </tr>
                  <tr>
                    <td>สนับสนุนการสอน</td>
                    <td>{{ personnel_etcsCounts.support_38 }}</td>
                    <td>ลูกจ้างประจำ</td>
                    <td>{{ personnel_etcsCounts.permanents }}</td>
                  </tr>
                  <tr>
                    <td>พนักงานราชการ(สายการสอน)</td>
                    <td>{{ personnel_etcsCounts.governmentteach }}</td>
                    <td>ครูอัตราจ้าง</td>
                    <td>{{ personnel_etcsCounts.temporarys }}</td>
                  </tr>
                  <tr>
                    <td>พนักงานราชการ(สายสนับสนุน)</td>
                    <td>{{ personnel_etcsCounts.governmentsp }}</td>
                    <td>ลูกจ้างชั่วคราว</td>
                    <td>{{ personnel_etcsCounts.temporary_jobs }}</td>
                  </tr>
                  <tr>
                    <td
                      colspan="2"
                      class="text-center font-weight-bold"
                      style="background-color: wheat;"
                    >
                      รวมทั้งสิ้น
                    </td>
                    <td
                      colspan="2"
                      class="text-center font-weight-bold"
                      style="background-color: wheat;"
                    >
                      {{ personnel_etcsCounts.sumAll }} คน
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col cols="12" md="4">
              <v-btn
                block
                depressed
                color="primary"
                @click.native="personnel_etcAdd()"
              >
                <v-icon>mdi-plus-circle-outline</v-icon>เพิ่มบุคลากร /
                ค้นหาข้าราชการจากระบบหลัก
              </v-btn>
              <v-btn
                block
                depressed
                color="info"
                class="mt-2"
                :href="'#/college/print_report_personnel_etc/' + user.user_code"
                target="_blank"
              >
                <v-icon>mdi-printer</v-icon>พิมพ์รายชื่อ
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

        <!-- ค้นหาบุคคลจากสถานศึกษาอื่น -->
        <v-card class="mb-3">
          <v-row no-gutters>
            <v-col cols="12" md="12" class="pa-5">
              <h2 class="font-weight-bold red--text">
                <v-icon>mdi-account-search</v-icon>
                ค้นหาบุคคลจากฐานข้อมูลงานอัตรากำลังของสถานศึกษาอื่น ๆ ในระบบ
              </h2>
            </v-col>
            <v-col cols="12" md="8" class="pa-1">
              <v-text-field
                v-model="searchIDcard"
                append-icon="mdi-magnify"
                label="ค้นหาบุคลากรในระบบอัตรากำลังจากสถานศึกษาอื่น ๆ : ด้วยรหัสบัตรประชาชน"
                single-line
                hide-details
                clearable
                solo-inverted
                flat
                class="mb-2"
              />
            </v-col>
            <v-col cols="12" md="4" class="pa-1">
              <v-btn
                block
                depressed
                color="info"
                @click.native="personnel_etcSearchSYS()"
              >
                <v-icon>mdi-account-search</v-icon>ค้นหา
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              md="12"
              v-if="personnel_etcSYSs.personnel_etc_id_card"
            >
              <v-form ref="addpersonnel_reqform" lazy-validation>
                <v-alert outlined type="warning" prominent>
                  <div>
                    {{ personnel_etcSYSs.college_name }}<br />
                    {{ personnel_etcSYSs.personnel_etc_id_card }}
                    {{ personnel_etcSYSs.personnel_etc_title }}
                    {{ personnel_etcSYSs.personnel_etc_fristname }}
                    {{ personnel_etcSYSs.personnel_etc_lastname }}
                  </div>
                  <div
                    v-if="
                      user.user_code !==
                        personnel_etcSYSs.personnel_etc_college_code
                    "
                  >
                    <v-btn color="primary" @click="personnel_reqAdd()"
                      >ขอเพิ่มข้อมูลบุคคล</v-btn
                    >
                  </div>
                  <div v-else>
                    <v-icon>mdi-information-outline</v-icon
                    >บุคคลดังกล่าวอยู่วิทยาลัยของท่าน
                  </div>
                </v-alert>
              </v-form>
            </v-col>
          </v-row>

          <!-- ตารางรายการขอเพิ่ม/ย้ายบุคคล -->
          <v-row no-gutters>
            <v-col cols="12" md="6" class="pa-2">
              <v-alert outlined color="green">
                <h3>รายการขอเพิ่มบุคคล</h3>
                <v-data-table
                  :headers="personnel_reqHearder"
                  :items="personnel_reqReqNTB"
                  :items-per-page="5"
                  class="elevation-1"
                >
                  <template v-slot:item.personel_reqIDcard="{ item }">
                    {{
                      item.personnel_etc_title +
                        item.personnel_etc_fristname +
                        " " +
                        item.personnel_etc_lastname
                    }}
                  </template>
                  <template v-slot:item.personel_reqStatus="{ item }">
                    <v-chip
                      dark
                      color="grey"
                      v-if="item.personel_reqStatus === 'req'"
                      >รอตรวจสอบ</v-chip
                    >
                  </template>
                  <template v-slot:item.personel_reqDate="{ item }">
                    {{
                      item.personel_reqDate
                        | moment("add", "543 years")
                        | moment("D MMMM YYYY")
                    }}
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-btn
                      rounded
                      color="warning"
                      @click="
                        cancelReg(
                          item.personel_reqNewCollege,
                          item.personel_reqIDcard
                        )
                      "
                    >
                      <v-icon>mdi-close</v-icon>ยกเลิก
                    </v-btn>
                  </template>
                </v-data-table>
              </v-alert>
            </v-col>
            <v-col cols="12" md="6" class="pa-2">
              <v-alert outlined color="warning">
                <h3>รายการขออนุมัติย้ายข้อมูลบุคคล</h3>
                <v-data-table
                  :headers="personnel_reqOHearder"
                  :items="personnel_reqReqOTB"
                  :items-per-page="5"
                  class="elevation-1"
                >
                  <template v-slot:item.personel_reqIDcard="{ item }">
                    {{
                      item.personnel_etc_title +
                        item.personnel_etc_fristname +
                        " " +
                        item.personnel_etc_lastname
                    }}
                  </template>
                  <template v-slot:item.personel_reqStatus="{ item }">
                    <v-btn
                      @click="personnel_reqApprove(item.personel_reqIDcard)"
                      color="green"
                      dark
                      v-if="item.personel_reqStatus === 'req'"
                      >อนุมัติย้ายข้อมูล</v-btn
                    >
                  </template>
                  <template v-slot:item.personel_reqDate="{ item }">
                    {{
                      item.personel_reqDate
                        | moment("add", "543 years")
                        | moment("D MMMM YYYY")
                    }}
                  </template>
                </v-data-table>
              </v-alert>
            </v-col>
          </v-row>
        </v-card>

        <!-- ค้นหาบุคคลในฐานข้อมูลของสถานศึกษา -->
        <v-alert outlined color="red" class="mb-3">
          <v-row no-gutters>
            <v-col cols="12" class="pa-5">
              <h2 class="font-weight-bold info--text">
                <v-icon>mdi-account-search</v-icon>
                ค้นหาบุคคลในฐานข้อมูลของ {{ user.college_name }}
              </h2>
            </v-col>
          </v-row>

          <!-- ตัวกรองประเภทบุคลากร -->
          <v-row no-gutters class="mb-2">
            <v-col cols="12" md="6" class="pa-1">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
                single-line
                hide-details
                clearable
                solo-inverted
                flat
              />
            </v-col>
            <v-col cols="12" md="3" class="pa-1">
              <v-select
                v-model="filterType"
                :items="filterTypeOptions"
                item-text="text"
                item-value="value"
                label="กรองตามประเภท"
                clearable
                outlined
                dense
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" md="3" class="pa-1">
              <v-select
                v-model="filterHelpStatus"
                :items="filterHelpOptions"
                item-text="text"
                item-value="value"
                label="กรองสถานะช่วยราชการ"
                clearable
                outlined
                dense
                hide-details
              ></v-select>
            </v-col>
          </v-row>

          <div class="font-weight-bold">
            <v-icon color="yellow">mdi-checkbox-blank</v-icon>
            ยังไม่ได้กำหนดประเภทบุคลากรให้ถูกต้อง ทำรายการที่ปุ่มแก้ไข
            <v-btn fab small dark color="warning"
              ><v-icon>mdi-pencil</v-icon></v-btn
            >
          </div>
          <div class="font-weight-bold">
            <v-icon color="amber">mdi-checkbox-blank</v-icon>
            ยังไม่ได้กำหนดประเภทวิชา สาขาวิชา ทำรายการที่ปุ่มแก้ไข
            <v-btn fab small dark color="warning"
              ><v-icon>mdi-pencil</v-icon></v-btn
            >
          </div>
          <div class="font-weight-bold">
            <v-icon color="red">mdi-checkbox-blank</v-icon>
            ปีหลักสูตรต่ำกว่า 2567 กรุณาปรับปรุงสาขาวิชาให้เป็นปัจจุบัน
          </div>
          <div>
            * หากไม่กำหนดให้ถูกต้องจะมีผลต่อการคำนวณอัตรากำลังของสถานศึกษา
          </div>
        </v-alert>

        <!-- เลือกคอลัมน์ -->
        <v-select
          v-model="selectedHeaders"
          :items="headers"
          label="เลือกคอลัมน์ที่ต้องการแสดง"
          multiple
          outlined
          return-object
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index < 6"
              ><span>{{ item.text }}</span></v-chip
            >
            <span v-if="index === 6" class="grey--text caption">
              (+{{ selectedHeaders.length - 6 }} คอลัมน์)
            </span>
          </template>
        </v-select>

        <!-- ตารางข้อมูลหลัก -->
        <v-data-table
          :loading="loading"
          :headers="showHeaders"
          :items="filteredPersonnelEtcs"
          :search="search"
          :item-class="row_classes"
          :expanded.sync="expanded"
          item-key="personnel_etc_id_card"
          show-expand
          single-expand
          disable-pagination
        >
          <!-- ============================================= -->
          <!-- คอลัมน์สรุปวุฒิการศึกษา (chip + จำนวน)         -->
          <!-- ============================================= -->
          <template v-slot:item.education_summary="{ item }">
            <div v-if="getEducation(item.personnel_etc_id_card).length">
              <v-chip
                v-for="(lv, i) in educationLevels(item.personnel_etc_id_card)"
                :key="i"
                x-small
                dark
                :color="eduLevelColor(lv)"
                class="mr-1 mb-1"
              >
                {{ lv }}
              </v-chip>
              <span class="caption grey--text">
                ({{ getEducation(item.personnel_etc_id_card).length }} วุฒิ)
              </span>
            </div>
            <span v-else class="grey--text">
              <v-icon small color="grey">mdi-school-outline</v-icon> ไม่มีข้อมูล
            </span>
          </template>

          <!-- ============================================= -->
          <!-- แถวขยาย: รายละเอียดวุฒิการศึกษาทั้งหมด          -->
          <!-- ============================================= -->
          <template v-slot:expanded-item="{ headers, item }">
            <td
              :colspan="headers.length"
              class="pa-3"
              style="background:#f7f9fc"
            >
              <div class="font-weight-bold mb-2 primary--text">
                <v-icon small color="primary">mdi-school</v-icon>
                ประวัติการศึกษา : {{ item.personnel_etc_title
                }}{{ item.personnel_etc_fristname }}
                {{ item.personnel_etc_lastname }}
              </div>

              <v-simple-table
                v-if="getEducation(item.personnel_etc_id_card).length"
                dense
                class="elevation-1"
              >
                <thead style="background:#e8eaf6">
                  <tr>
                    <th class="text-left">ระดับ</th>
                    <th class="text-left">วุฒิ/คณะ</th>
                    <th class="text-left">สาขาวิชา</th>
                    <th class="text-left">สถาบัน</th>
                    <th class="text-center">ปีที่จบ</th>
                    <th class="text-center">ผลการเรียน</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(ed, idx) in getEducation(
                      item.personnel_etc_id_card
                    )"
                    :key="idx"
                  >
                    <td>
                      <v-chip
                        x-small
                        dark
                        :color="eduLevelColor(ed.education_level)"
                      >
                        {{ ed.education_level || "-" }}
                      </v-chip>
                    </td>
                    <td>{{ ed.faculty_name || "-" }}</td>
                    <td>{{ ed.branch_name || "-" }}</td>
                    <td>{{ ed.academy_name || "-" }}</td>
                    <td class="text-center">{{ ed.year_finish || "-" }}</td>
                    <td class="text-center">
                      {{
                        ed.academic_results != null ? ed.academic_results : "-"
                      }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>

              <v-alert v-else dense outlined type="info" class="mb-0">
                ยังไม่มีข้อมูลวุฒิการศึกษาในตาราง personnel_education —
                สามารถเพิ่มได้ที่ปุ่มแก้ไข
              </v-alert>
            </td>
          </template>
          <template v-slot:item.personnel_etc_m_type="{ item }">
            <v-chip
              small
              :color="getPersonnelTypeChipColor(item.personnel_etc_m_type)"
              :dark="!!item.personnel_etc_m_type"
              :outlined="!item.personnel_etc_m_type"
              class="font-weight-medium"
              style="min-width:120px; justify-content:center"
            >
              <v-icon left x-small v-if="item.personnel_etc_m_type">{{
                getPersonnelTypeIcon(item.personnel_etc_m_type)
              }}</v-icon>
              {{ getPersonnelTypeLabel(item.personnel_etc_m_type) }}
            </v-chip>
          </template>

          <!-- ช่วยราชการ -->
          <template v-slot:item.personnel_etc_help_status="{ item }">
            <v-chip
              small
              color="orange"
              dark
              v-if="item.personnel_etc_help_status === 'helping'"
            >
              <v-icon small left>mdi-arrow-right-bold</v-icon>ไปช่วยราชการ
            </v-chip>
            <v-chip
              small
              color="teal"
              dark
              v-else-if="item.personnel_etc_help_status === 'receiving'"
            >
              <v-icon small left>mdi-arrow-left-bold</v-icon>รับช่วยราชการ
            </v-chip>
            <span v-else>-</span>
          </template>

          <template v-slot:item.personnel_etc_help_college_code="{ item }">
            <span v-if="item.personnel_etc_help_college_code">
              {{
                item.help_college_name || item.personnel_etc_help_college_code
              }}
            </span>
            <span v-else>-</span>
          </template>

          <!-- งาน (หลายงาน) -->
          <template v-slot:item.personnel_etc_workgroup="{ item }">
            <div v-if="item.personnel_etc_workgroup">
              <v-chip
                v-for="wg in parseWorkgroups(item.personnel_etc_workgroup)"
                :key="wg"
                small
                class="mr-1 mb-1"
                color="blue-grey lighten-4"
                >{{ getWorkgroupName(wg) }}</v-chip
              >
            </div>
            <span v-else>-</span>
          </template>

          <!-- ============================================= -->
          <!-- ชั่วโมงสอน — เพิ่มแจ้งเตือนตามรอบรายงาน       -->
          <!-- ============================================= -->
          <template v-slot:item.personnel_etc_teach_hours_s1="{ item }">
            <div v-if="isTeachingType(item.personnel_etc_m_type)">
              <v-chip
                x-small
                v-if="item.personnel_etc_teach_hours_s1"
                :color="
                  parseInt(item.personnel_etc_teach_hours_s1) >= 18
                    ? 'success'
                    : 'warning'
                "
                dark
                >{{ item.personnel_etc_teach_hours_s1 }} ชม.</v-chip
              >
              <!-- แจ้งเตือนถ้ารอบ 3 (พฤษภาคม) เปิดอยู่แต่ยังไม่กรอก ภ.1 -->
              <v-tooltip bottom v-else-if="activeRoundTeachSemester === 1">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="red" size="24" v-bind="attrs" v-on="on"
                    >mdi-alert-circle</v-icon
                  >
                </template>
                <span
                  >กรุณากรอกชั่วโมงสอน ภาคเรียนที่ 1
                  ตามรอบรายงานที่เปิดอยู่</span
                >
              </v-tooltip>
              <span v-else class="grey--text">-</span>
            </div>
          </template>
          <template v-slot:item.personnel_etc_teach_hours_s2="{ item }">
            <div v-if="isTeachingType(item.personnel_etc_m_type)">
              <v-chip
                x-small
                v-if="item.personnel_etc_teach_hours_s2"
                :color="
                  parseInt(item.personnel_etc_teach_hours_s2) >= 18
                    ? 'success'
                    : 'warning'
                "
                dark
                >{{ item.personnel_etc_teach_hours_s2 }} ชม.</v-chip
              >
              <!-- แจ้งเตือนถ้ารอบ 1 (ตุลาคม) เปิดอยู่แต่ยังไม่กรอก ภ.2 -->
              <v-tooltip bottom v-else-if="activeRoundTeachSemester === 2">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="red" size="24" v-bind="attrs" v-on="on"
                    >mdi-alert-circle</v-icon
                  >
                </template>
                <span
                  >กรุณากรอกชั่วโมงสอน ภาคเรียนที่ 2
                  ตามรอบรายงานที่เปิดอยู่</span
                >
              </v-tooltip>
              <span v-else class="grey--text">-</span>
            </div>
          </template>

          <!-- ============================================= -->
          <!-- ปีหลักสูตร — เพิ่มแจ้งเตือนถ้าต่ำกว่า 2567    -->
          <!-- ============================================= -->
          <template v-slot:item.year_course="{ item }">
            <div v-if="isTeachingType(item.personnel_etc_m_type)">
              <v-chip v-if="item.personnel_etc_subject === '66'">
                -
              </v-chip>

              <v-chip
                small
                v-else-if="
                  item.year_course && parseInt(item.year_course) >= 2567
                "
                color="success"
                dark
              >
                {{ item.year_course }}
              </v-chip>
              <v-tooltip bottom v-else>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip small color="red" dark v-bind="attrs" v-on="on">
                    <v-icon small left>mdi-alert</v-icon>
                    {{ item.year_course || "ไม่ระบุ" }}
                  </v-chip>
                </template>
                <span
                  >ปีหลักสูตรต่ำกว่า 2567
                  กรุณาปรับปรุงสาขาวิชาให้เป็นหลักสูตรปัจจุบัน</span
                >
              </v-tooltip>
            </div>
            <span v-else>-</span>
          </template>

          <template v-slot:item.reset="{ item }">
            <v-btn            
              fab
              small
              dark
              color="warning"
              @click="personnel_etcReset(item.personnel_etc_id_card)"
              ><v-icon>mdi-reload</v-icon></v-btn
            >
          </template>

          <template v-slot:item.personnel_etc_idplan="{ item }">
            <v-chip
              color="primary"
              v-if="item.personnel_etc_idplan === 'update'"
            >
              <v-icon>mdi-checkbox-marked-circle</v-icon>ID PLAN
            </v-chip>
          </template>

          <template v-slot:item.personnel_etc_salary="{ item }">
            <span class="font-weight-medium" v-if="item.personnel_etc_salary">
              {{ Number(item.personnel_etc_salary).toLocaleString() }}
              <span class="caption grey--text">฿</span>
            </span>
            <span v-else class="grey--text">-</span>
          </template>

          <template v-slot:item.personnel_etc_safety="{ item }">
            <div v-if="isTemporary(item.personnel_etc_m_type)">
              <v-icon v-if="!item.personnel_etc_safety" color="error" size="30"
                >mdi-alert</v-icon
              >
              <span v-else>{{ item.personnel_etc_safety }}</span>
            </div>
          </template>

          <template v-slot:item.budget_etcdetail="{ item }">
            <div v-if="isTemporary(item.personnel_etc_m_type)">
              <v-icon v-if="!item.budget_etcdetail" color="error" size="30"
                >mdi-alert</v-icon
              >
              <span v-else>{{ item.budget_etcdetail }}</span>
            </div>
          </template>

          <template v-slot:item.personnel_etc_subject="{ item }">
            <div
              v-if="isTeachingType(item.personnel_etc_m_type)"
              class="text-center"
            >
              <v-chip v-if="item.personnel_etc_subject" color="primary">{{
                item.subject_typeName
              }}</v-chip>
              <v-chip v-else color="warning">กรุณาเลือกประเภทวิชา</v-chip>
            </div>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              fab
              small
              dark
              color="warning"
              @click="personnel_etcEdit(item.personnel_etc_id_card)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>

          <template v-slot:item.action_s="{ item }">
            <v-btn
              fab
              small
              dark
              color="red"
              @click="personnel_etcDelete(item.personnel_etc_id_card)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>

          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
          >
            ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา.
          </v-alert>
        </v-data-table>
      </base-material-card>

      <!-- =============================================== -->
      <!-- Dialog: เพิ่มบุคลากร                            -->
      <!-- =============================================== -->
      <v-layout row justify-center>
        <v-dialog
          v-model="addpersonnel_etcdialog"
          persistent
          max-width="80%"
          overlay-opacity="0.6"
        >
          <v-card class="mx-auto pa-5">
            <base-material-card
              icon="mdi-clipboard-text"
              title="เพิ่มข้อมูล ลูกจ้างประจำ พนักงานราชการ ครูอัตราจ้างหรือลูกจ้างชั่วคราว"
              class="px-5 py-3"
            ></base-material-card>
            <v-form ref="addpersonnel_etcform" lazy-validation>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex md12>
                    <!-- ค้นหาข้าราชการจากระบบหลัก -->
                    <v-alert
                      colored-border
                      type="info"
                      elevation="2"
                      class="pa-0"
                    >
                      <v-row no-gutters>
                        <v-col cols="12" md="8" class="pa-1">
                          <v-select
                            v-model="addpersonnel_etc.typeNationalityS"
                            :items="typeNationality"
                            item-text="text"
                            item-value="value"
                            label="เลือกสัญชาติ"
                            outlined
                            :rules="[v => !!v || '']"
                          ></v-select>
                          <v-text-field
                            v-if="addpersonnel_etc.typeNationalityS === '0'"
                            @input="validateInput()"
                            outlined
                            v-model="addpersonnel_etc.personnel_etc_id_card"
                            label="ค้นหาข้าราชการจากระบบหลัก : รหัสบัตรประชาชน"
                            :rules="idCardRulesAdd"
                            maxlength="13"
                          ></v-text-field>
                          <span class="red--text font-weight-bold">
                            * ปุ่มค้นหาจะปรากฎเมื่อกรอกหมายเลขบัตรประชาชนถูกต้อง
                          </span>
                        </v-col>
                        <v-col cols="12" md="4" class="text-center">
                          <v-btn
                            v-if="
                              validateInputcheck === 'true' &&
                                addpersonnel_etc.typeNationalityS === '0'
                            "
                            rounded
                            color="info"
                            @click="personnel_temporaryQuery()"
                          >
                            <v-icon>mdi-account-search</v-icon>ค้นหา
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-alert>

                    <!-- ฟอร์มเพิ่มข้อมูล -->
                    <v-alert
                      colored-border
                      color="#34CDC1"
                      elevation="2"
                      class="pa-2"
                    >
                      <div class="text-center pa-5">
                        <span class="primary--text font-weight-bold">
                          เพิ่มข้อมูล ลูกจ้างประจำ พนักงานราชการ และ
                          ลูกจ้างชั่วคราว
                        </span>
                      </div>

                      <!-- ประเภทบุคลากร -->
                      <v-row no-gutters>
                        <v-col cols="12">
                          <v-select
                            outlined
                            v-model="addpersonnel_etc.personnel_etc_m_type"
                            :items="type_personnel"
                            item-text="text"
                            item-value="value"
                            label="ประเภทบุคลากร"
                            :rules="[v => !!v || '']"
                          ></v-select>
                        </v-col>
                      </v-row>

                      <hr />

                      <!-- ข้อมูลพื้นฐาน -->
                      <v-row no-gutters>
                        <v-col cols="12">
                          <div class="font-weight-bold">
                            <v-icon>mdi-account-box</v-icon>ข้อมูลพื้นฐาน
                          </div>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                          class="pa-1"
                          v-if="addpersonnel_etc.typeNationalityS === '0'"
                        >
                          <v-text-field
                            @input="validateInput()"
                            outlined
                            v-model="addpersonnel_etc.personnel_etc_id_card"
                            label="รหัสบัตรประชาชน"
                            :rules="idCardRulesAdd"
                            maxlength="13"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                          class="pa-1"
                          v-if="
                            addpersonnel_etc.typeNationalityS === '1' ||
                              addpersonnel_etc.typeNationalityS === 1
                          "
                        >
                          <v-text-field
                            outlined
                            v-model="addpersonnel_etc.personnel_etc_id_card"
                            label="รหัสบัตรประชาชน"
                            :rules="[v => !!v || 'This field is required']"
                            maxlength="13"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" class="pa-1">
                          <v-autocomplete
                            :items="prefixs"
                            item-text="prefix_name"
                            item-value="prefix_name"
                            outlined
                            v-model="addpersonnel_etc.personnel_etc_title"
                            label="คำนำหน้าชื่อ"
                            :rules="[v => !!v || '']"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="3" class="pa-1">
                          <v-text-field
                            outlined
                            v-model="addpersonnel_etc.personnel_etc_fristname"
                            label="ชื่อ"
                            :rules="[v => !!v || '']"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" class="pa-1">
                          <v-text-field
                            outlined
                            v-model="addpersonnel_etc.personnel_etc_lastname"
                            label="นามสกุล"
                            :rules="[v => !!v || '']"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12"><hr /></v-col>

                        <!-- ข้อมูลด้านการทำงาน -->
                        <v-col cols="12">
                          <div class="font-weight-bold">
                            <v-icon>mdi-briefcase</v-icon>ข้อมูลด้านการทำงาน
                          </div>
                        </v-col>

                        <!-- งาน (หลายงาน) -->
                        <v-col cols="12" md="6" class="pa-1">
                          <v-autocomplete
                            :items="workgroups"
                            item-text="workGroupName"
                            item-value="workGroupID"
                            outlined
                            multiple
                            chips
                            small-chips
                            deletable-chips
                            v-model="addpersonnel_etc.personnel_etc_workgroup"
                            label="ภารกิจ/งาน (เลือกได้หลายงาน)"
                          ></v-autocomplete>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3"
                          class="pa-1"
                          v-if="
                            showIdPosition(
                              addpersonnel_etc.personnel_etc_m_type
                            )
                          "
                        >
                          <v-text-field
                            outlined
                            v-model="addpersonnel_etc.personnel_etc_id_position"
                            label="เลขที่ตำแหน่ง"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                          class="pa-1"
                          v-if="
                            showRankLevel(addpersonnel_etc.personnel_etc_m_type)
                          "
                        >
                          <v-select
                            :items="rang_levels"
                            item-text="text"
                            item-value="value"
                            outlined
                            v-model="addpersonnel_etc.personnel_etc_level"
                            label="อันดับ/ระดับ"
                          ></v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                          class="pa-1"
                          v-if="
                            showRankLevel(addpersonnel_etc.personnel_etc_m_type)
                          "
                        >
                          <v-select
                            :items="rang_names"
                            item-text="text"
                            item-value="value"
                            outlined
                            v-model="addpersonnel_etc.personnel_etc_rang"
                            label="วิทยฐานะ"
                          ></v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                          class="pa-1"
                          v-if="
                            isGovernment(addpersonnel_etc.personnel_etc_m_type)
                          "
                        >
                          <v-text-field
                            outlined
                            v-model="addpersonnel_etc.personnel_etc_type"
                            label="ประเภท"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                          class="pa-1"
                          v-if="
                            isGovernment(addpersonnel_etc.personnel_etc_m_type)
                          "
                        >
                          <v-text-field
                            outlined
                            v-model="addpersonnel_etc.personnel_etc_about"
                            label="ด้าน"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                          class="pa-1"
                          v-if="
                            isTemporary(addpersonnel_etc.personnel_etc_m_type)
                          "
                        >
                          <v-select
                            outlined
                            v-model="addpersonnel_etc.personnel_etc_safety"
                            label="ประกันสังคม"
                            :items="safety"
                            item-text="text"
                            item-value="value"
                          ></v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                          class="pa-1"
                          v-if="
                            isTemporary(addpersonnel_etc.personnel_etc_m_type)
                          "
                        >
                          <v-select
                            outlined
                            v-model="addpersonnel_etc.personnel_etc_budget"
                            label="งบประมาณ"
                            :items="budget_etcs"
                            item-text="budget_etcdetail"
                            item-value="budget_etcid"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" md="3" class="pa-1">
                          <v-text-field
                            outlined
                            v-model="addpersonnel_etc.personnel_etc_salary"
                            label="อัตราเงินเดือน"
                            type="number"
                          ></v-text-field>
                        </v-col>

                        <!-- ===== ประเภทวิชา/สาขาวิชา (สายการสอน) ===== -->
                        <template
                          v-if="
                            isTeachingType(
                              addpersonnel_etc.personnel_etc_m_type
                            )
                          "
                        >
                          <v-col cols="12"><hr /></v-col>
                          <v-col cols="12">
                            <div class="font-weight-bold">
                              <v-icon>mdi-book-open-variant</v-icon
                              >ข้อมูลสาขาวิชาและชั่วโมงสอน
                            </div>

                            <!-- แจ้งเตือนรอบรายงานใน Dialog เพิ่ม -->
                            <v-alert
                              v-if="activeRound && activeRound.round_id"
                              dense
                              outlined
                              type="info"
                              class="mt-2"
                            >
                              <strong>รอบรายงานที่เปิดอยู่:</strong>
                              {{ activeRound.round_name }}
                              — กรุณากรอก{{ activeRoundTeachSemesterLabel }}
                            </v-alert>
                          </v-col>
                          <v-col cols="12" md="4" class="pa-1">
                            <v-autocomplete
                              outlined
                              v-model="addpersonnel_etc.personnel_etc_subject"
                              :items="subject_types"
                              item-text="subject_typeName"
                              item-value="subject_typeID"
                              label="ประเภทวิชา"
                              @change="onSubjectChangeAdd()"
                            >
                              <template v-slot:item="{ item }">
                                <div>
                                  <div style="font-weight: bold;">
                                    {{ item.subject_typeID }} :
                                    {{ item.subject_typeName }}
                                  </div>
                                </div>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="4" class="pa-1">
                            <v-autocomplete
                              outlined
                              dense
                              hide-details="auto"
                              v-model="addpersonnel_etc.personnel_etc_branch"
                              :items="rate_work_course_stds"
                              :item-text="
                                addpersonnel_etc.personnel_etc_subject === '66'
                                  ? 'short_courseSTBranch'
                                  : 'branch_name_th'
                              "
                              :item-value="
                                addpersonnel_etc.personnel_etc_subject === '66'
                                  ? 'short_courseSTBranchID'
                                  : 'id_course_branch'
                              "
                              label="2. สาขาวิชา"
                              prepend-inner-icon="mdi-numeric-2-circle"
                              :disabled="
                                !addpersonnel_etc.personnel_etc_subject
                              "
                              :hint="
                                !addpersonnel_etc.personnel_etc_subject
                                  ? 'เลือกประเภทวิชาก่อน'
                                  : ''
                              "
                              persistent-hint
                              @change="onBranchChangeAdd()"
                            >
                              <template v-slot:item="{ item }">
                                <div class="py-1" style="max-width:400px">
                                  <div
                                    class="font-weight-bold"
                                    style="color:#1565c0"
                                  >
                                    <v-icon x-small color="primary" class="mr-1"
                                      >mdi-book-open-variant</v-icon
                                    >
                                    <span
                                      v-if="
                                        addpersonnel_etc.personnel_etc_subject ===
                                          '66'
                                      "
                                    >
                                      {{ item.short_courseSTBranchID }} :
                                      {{ item.short_courseSTBranch }}
                                    </span>
                                    <span v-else>
                                      <span
                                        v-if="item.rate_work_level_class === 20"
                                        >ปวช.</span
                                      >
                                      <span
                                        v-else-if="
                                          item.rate_work_level_class === 30
                                        "
                                        >ปวส.</span
                                      >
                                      <span
                                        v-else-if="
                                          item.rate_work_level_class === 40
                                        "
                                        >ปวส.</span
                                      >
                                      <span v-else>-</span>
                                      {{ item.branch_name_th }}</span
                                    >
                                  </div>
                                  <div class="caption grey--text ml-5">
                                    <span
                                      v-if="
                                        addpersonnel_etc.personnel_etc_subject ===
                                          '66'
                                      "
                                    >
                                      กลุ่ม: {{ item.short_courseGroupName }}
                                    </span>
                                    <span v-else>
                                      ปี {{ item.year_course }} | ประเภทวิชา:
                                      {{ item.type_course }}
                                    </span>
                                  </div>
                                </div>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="4" class="pa-1">
                            <v-autocomplete
                              outlined
                              v-model="
                                addpersonnel_etc.personnel_etc_branch_sub
                              "
                              :items="rate_work_course_stdSubs"
                              :item-text="
                                addpersonnel_etc.personnel_etc_subject === '66'
                                  ? 'short_courseName'
                                  : 'branch_sub_name_th'
                              "
                              :item-value="
                                addpersonnel_etc.personnel_etc_subject === '66'
                                  ? 'short_courseID'
                                  : 'id_course_branch_sub'
                              "
                              label="สาขางาน (เฉพาะผู้ที่ทำหน้าที่สอน)"
                            >
                              <template v-slot:item="{ item }">
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{
                                      item.year_course || item.branch_name_th
                                    }}
                                  </v-list-item-title>
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>
                          </v-col>

                          <!-- ===== ชั่วโมงสอน ===== -->
                          <v-col cols="12" md="3" class="pa-1">
                            <v-text-field
                              outlined
                              v-model="
                                addpersonnel_etc.personnel_etc_teach_year
                              "
                              label="ปีการศึกษา"
                              placeholder="เช่น 2568"
                              maxlength="4"
                              type="number"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="3" class="pa-1">
                            <v-text-field
                              outlined
                              v-model="
                                addpersonnel_etc.personnel_etc_teach_hours_s1
                              "
                              label="ชั่วโมงสอน/สัปดาห์ (ภาคเรียนที่ 1)"
                              type="number"
                              min="0"
                              max="40"
                              hint="จำนวนชั่วโมงสอนต่อสัปดาห์"
                              persistent-hint
                              :background-color="
                                activeRoundTeachSemester === 1 ? '#FFF8E1' : ''
                              "
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="3" class="pa-1">
                            <v-text-field
                              outlined
                              v-model="
                                addpersonnel_etc.personnel_etc_teach_hours_s2
                              "
                              label="ชั่วโมงสอน/สัปดาห์ (ภาคเรียนที่ 2)"
                              type="number"
                              min="0"
                              max="40"
                              hint="จำนวนชั่วโมงสอนต่อสัปดาห์"
                              persistent-hint
                              :background-color="
                                activeRoundTeachSemester === 2 ? '#FFF8E1' : ''
                              "
                            ></v-text-field>
                          </v-col>
                        </template>

                        <v-col cols="12"><hr /></v-col>

                        <!-- ข้อมูลด้านการศึกษา -->
                        <v-col cols="12">
                          <div class="font-weight-bold">
                            <v-icon>mdi-school</v-icon>ข้อมูลด้านการศึกษา
                          </div>
                        </v-col>
                        <v-col cols="12" md="6" class="pa-1">
                          <v-text-field
                            outlined
                            v-model="addpersonnel_etc.personnel_etc_education_1"
                            label="วุฒิการศึกษา(สาขาวิชา) ต่ำกว่า ป.ตรี"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pa-1">
                          <v-text-field
                            outlined
                            v-model="addpersonnel_etc.personnel_etc_education_2"
                            label="วุฒิการศึกษา(สาขาวิชา) ปริญญาตรี"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pa-1">
                          <v-text-field
                            outlined
                            v-model="addpersonnel_etc.personnel_etc_education_3"
                            label="วุฒิการศึกษา(สาขาวิชา) ปริญญาโท"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pa-1">
                          <v-text-field
                            outlined
                            v-model="addpersonnel_etc.personnel_etc_education_4"
                            label="วุฒิการศึกษา(สาขาวิชา) ปริญญาเอก"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-alert>
                  </v-flex>
                </v-layout>
                <v-spacer></v-spacer>
                <hr />
                <v-row>
                  <v-col cols="12" v-if="validateInputcheck === 'false'">
                    <div class="text-right red--text font-weight-bold">
                      กำหนดรหัสบัตรประชาชนไม่ถูกต้อง ไม่สามารถบันทึกข้อมูลได้
                    </div>
                  </v-col>
                  <v-col cols="12" class="text-right">
                    <v-btn
                      outlined
                      color="warning"
                      @click.stop="addpersonnel_etcdialog = false"
                      rounded
                      class="mr-2"
                    >
                      <v-icon dark>mdi-close</v-icon>ยกเลิก
                    </v-btn>
                    <v-btn
                      v-if="
                        validateInputcheck === 'true' ||
                          addpersonnel_etc.typeNationalityS === '1' ||
                          addpersonnel_etc.typeNationalityS === 1
                      "
                      color="success"
                      @click.stop="addpersonnel_etcSubmit()"
                      rounded
                    >
                      <v-icon dark>mdi-content-save</v-icon>&nbsp;&nbsp;บันทึก
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- =============================================== -->
      <!-- Dialog: ค้นพบข้อมูลจากระบบหลัก                   -->
      <!-- =============================================== -->
      <v-layout>
        <v-dialog
          v-model="searchPersonnel_etcdialog"
          persistent
          max-width="50%"
        >
          <v-card class="mx-auto pa-5">
            <base-material-card
              color="success"
              icon="mdi-account-check"
              title="ค้นพบข้อมูล"
              class="px-5 py-3"
            ></base-material-card>
            <v-card-text>
              <v-form ref="searchPersonnel_etcdialogform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      ยืนยันการนำเข้าข้อมูล :
                      <v-list>
                        <v-list-item>
                          <v-list-item-icon
                            ><v-icon color="indigo"
                              >mdi-account-check</v-icon
                            ></v-list-item-icon
                          >
                          <v-list-item-content>
                            <v-list-item-title
                              >รหัสบัตรประชาชน</v-list-item-title
                            >
                            <v-list-item-subtitle>{{
                              personnel_temporarys.id_card
                            }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider inset></v-divider>
                        <v-list-item>
                          <v-list-item-icon
                            ><v-icon color="indigo"
                              >mdi-account-card-details</v-icon
                            ></v-list-item-icon
                          >
                          <v-list-item-content>
                            <v-list-item-title>ชื่อ-นามสกุล</v-list-item-title>
                            <v-list-item-subtitle>
                              {{ personnel_temporarys.title_s
                              }}{{ personnel_temporarys.frist_name }}
                              {{ personnel_temporarys.last_name }}
                              เลขที่ตำแหน่ง
                              {{ personnel_temporarys.id_position }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider inset></v-divider>
                        <v-list-item>
                          <v-list-item-icon
                            ><v-icon color="indigo"
                              >mdi-map-marker</v-icon
                            ></v-list-item-icon
                          >
                          <v-list-item-content>
                            <v-list-item-title>ปัจจุบัน</v-list-item-title>
                            <v-list-item-subtitle>{{
                              personnel_temporarys.college_name
                            }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-flex>
                    <v-flex xs12>
                      <template
                        v-if="
                          isTeachingTypeByStatus(
                            personnel_temporarys.user_status
                          )
                        "
                      >
                        <v-autocomplete
                          outlined
                          v-model="addpersonnel_etc.personnel_etc_subject"
                          :items="subject_types"
                          item-text="subject_typeName"
                          item-value="subject_typeID"
                          label="ประเภทวิชา"
                          :rules="[v => !!v || '']"
                          @change="onSubjectChangeSearch()"
                        ></v-autocomplete>
                        <v-autocomplete
                          outlined
                          v-model="addpersonnel_etc.personnel_etc_branch"
                          :items="rate_work_course_stds"
                          :item-text="
                            addpersonnel_etc.personnel_etc_subject === '66'
                              ? 'short_courseSTBranch'
                              : 'branch_name_th'
                          "
                          :item-value="
                            addpersonnel_etc.personnel_etc_subject === '66'
                              ? 'short_courseSTBranchID'
                              : 'id_course_branch'
                          "
                          label="สาขาวิชา (เฉพาะผู้ที่ทำหน้าที่สอน)"
                          @change="onBranchChangeSearch()"
                        >
                          <template v-slot:item="{ item }">
                            <div class="py-1" style="max-width:400px">
                              <div
                                class="font-weight-bold"
                                style="color:#1565c0"
                              >
                                <v-icon x-small color="primary" class="mr-1"
                                  >mdi-book-open-variant</v-icon
                                >
                                <span
                                  v-if="
                                    addpersonnel_etc.personnel_etc_subject ===
                                      '66'
                                  "
                                >
                                  {{ item.short_courseSTBranchID }} :
                                  {{ item.short_courseSTBranch }}
                                </span>
                                <span v-else>{{ item.branch_name_th }}</span>
                              </div>
                              <div class="caption grey--text ml-5">
                                <span
                                  v-if="
                                    addpersonnel_etc.personnel_etc_subject ===
                                      '66'
                                  "
                                >
                                  กลุ่ม: {{ item.short_courseGroupName }}
                                </span>
                                <span v-else>
                                  ปี {{ item.year_course }} | ประเภทวิชา:
                                  {{ item.type_course }}
                                </span>
                              </div>
                            </div>
                          </template>
                        </v-autocomplete>
                        <v-autocomplete
                          outlined
                          dense
                          hide-details="auto"
                          v-model="addpersonnel_etc.personnel_etc_branch_sub"
                          :items="rate_work_course_stdSubs"
                          :item-text="
                            addpersonnel_etc.personnel_etc_subject === '66'
                              ? 'short_courseName'
                              : 'branch_sub_name_th'
                          "
                          :item-value="
                            addpersonnel_etc.personnel_etc_subject === '66'
                              ? 'short_courseID'
                              : 'id_course_branch_sub'
                          "
                          label="3. สาขางาน"
                          prepend-inner-icon="mdi-numeric-3-circle"
                          :disabled="!addpersonnel_etc.personnel_etc_branch"
                          :hint="
                            !addpersonnel_etc.personnel_etc_branch
                              ? 'เลือกสาขาวิชาก่อน'
                              : ''
                          "
                          persistent-hint
                        >
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title>
                                ปี {{ item.year_course }} งาน
                                {{ item.branch_sub_name_th }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </v-autocomplete>
                      </template>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn rounded @click.stop="searchPersonnel_etcdialog = false">
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                rounded
                color="green"
                @click.stop="searchPersonnel_etcdialogSubmit()"
                dark
              >
                <v-icon dark>mdi-content-save-settings</v-icon
                >&nbsp;ยืนยันการนำเข้าข้อมูล
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- =============================================== -->
      <!-- Dialog: ลบข้อมูล                                -->
      <!-- =============================================== -->
      <v-layout>
        <v-dialog
          v-model="deletepersonnel_etcdialog"
          persistent
          max-width="40%"
        >
          <v-card class="mx-auto pa-5">
            <base-material-card
              color="error"
              icon="mdi-delete"
              title="ลบข้อมูล"
              class="px-5 py-3"
            ></base-material-card>
            <v-card-text>
              <v-form ref="deletepersonnel_etcform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      ยืนยันการลบข้อมูล :
                      <h3>{{ editpersonnel_etc.personnel_etc_id_card }}</h3>
                    </v-flex>
                    <v-flex xs12 md6>
                      {{ editpersonnel_etc.personnel_etc_title
                      }}{{ editpersonnel_etc.personnel_etc_fristname }}
                      {{ editpersonnel_etc.personnel_etc_lastname }}
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click.stop="deletepersonnel_etcdialog = false">
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                color="red darken-3"
                @click.stop="deletepersonnel_etcubmit()"
                dark
              >
                <v-icon dark>mdi-delete</v-icon>&nbsp;ลบ
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- =============================================== -->
      <!-- Dialog: แก้ไขข้อมูลบุคลากร                       -->
      <!-- =============================================== -->
      <v-layout row justify-center>
        <v-dialog v-model="editpersonnel_etcdialog" persistent max-width="80%">
          <v-card class="mx-auto pa-5">
            <base-material-card
              color="yellow"
              icon="mdi-clipboard-text"
              title="แก้ไขข้อมูลบุคลากร"
              class="px-5 py-3"
            ></base-material-card>
            <v-card-text>
              <v-form ref="editpersonnel_etcform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md12>
                      <!-- ประเภทบุคลากร -->
                      <v-row no-gutters>
                        <v-col cols="12">
                          <v-select
                            v-if="
                              isGovType(editpersonnel_etc.personnel_etc_m_type)
                            "
                            outlined
                            v-model="editpersonnel_etc.personnel_etc_m_type"
                            :items="type_personnelGov"
                            item-text="text"
                            item-value="value"
                            label="ประเภทบุคลากร"
                            :rules="[v => !!v || '']"
                          ></v-select>
                          <v-select
                            v-else
                            outlined
                            v-model="editpersonnel_etc.personnel_etc_m_type"
                            :items="type_personnel"
                            item-text="text"
                            item-value="value"
                            label="ประเภทบุคลากร"
                            :rules="[v => !!v || '']"
                          ></v-select>
                        </v-col>
                      </v-row>

                      <hr />

                      <!-- ข้อมูลพื้นฐาน -->
                      <v-row no-gutters>
                        <v-col cols="12">
                          <div class="font-weight-bold">
                            <v-icon>mdi-account-box</v-icon>ข้อมูลพื้นฐาน
                          </div>
                        </v-col>
                        <v-col cols="12" md="6" class="pa-1">
                          <v-select
                            v-model="editpersonnel_etc.typeNationalityS"
                            :items="typeNationality"
                            item-text="text"
                            item-value="value"
                            label="เลือกสัญชาติ"
                            outlined
                            :rules="[v => !!v || '']"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" md="6" class="pa-1">
                          <v-text-field
                            outlined
                            v-model="editpersonnel_etc.personnel_etc_id_card"
                            label="รหัสบัตรประชาชน"
                            readonly
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" class="pa-1">
                          <v-autocomplete
                            :items="prefixs"
                            item-text="prefix_name"
                            item-value="prefix_name"
                            outlined
                            v-model="editpersonnel_etc.personnel_etc_title"
                            label="คำนำหน้าชื่อ"
                            :rules="[v => !!v || '']"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="4" class="pa-1">
                          <v-text-field
                            outlined
                            v-model="editpersonnel_etc.personnel_etc_fristname"
                            label="ชื่อ"
                            :rules="[v => !!v || '']"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" class="pa-1">
                          <v-text-field
                            outlined
                            v-model="editpersonnel_etc.personnel_etc_lastname"
                            label="นามสกุล"
                            :rules="[v => !!v || '']"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12"><hr /></v-col>

                        <!-- ข้อมูลด้านการทำงาน -->
                        <v-col cols="12">
                          <div class="font-weight-bold">
                            <v-icon>mdi-briefcase</v-icon>ข้อมูลด้านการทำงาน
                          </div>
                        </v-col>

                        <!-- งาน (หลายงาน) -->
                        <v-col cols="12" md="6" class="pa-1">
                          <v-autocomplete
                            :items="workgroups"
                            item-text="workGroupName"
                            item-value="workGroupID"
                            outlined
                            multiple
                            chips
                            small-chips
                            deletable-chips
                            v-model="editpersonnel_etc.personnel_etc_workgroup"
                            label="ภารกิจ/งาน (เลือกได้หลายงาน)"
                          ></v-autocomplete>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3"
                          class="pa-1"
                          v-if="
                            showIdPosition(
                              editpersonnel_etc.personnel_etc_m_type
                            )
                          "
                        >
                          <v-text-field
                            outlined
                            v-model="
                              editpersonnel_etc.personnel_etc_id_position
                            "
                            label="เลขที่ตำแหน่ง"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                          class="pa-1"
                          v-if="
                            showRankLevel(
                              editpersonnel_etc.personnel_etc_m_type
                            )
                          "
                        >
                          <v-select
                            :items="rang_levels"
                            item-text="text"
                            item-value="value"
                            outlined
                            v-model="editpersonnel_etc.personnel_etc_level"
                            label="อันดับ/ระดับ"
                          ></v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                          class="pa-1"
                          v-if="
                            showRankLevel(
                              editpersonnel_etc.personnel_etc_m_type
                            )
                          "
                        >
                          <v-select
                            :items="rang_names"
                            item-text="text"
                            item-value="value"
                            outlined
                            v-model="editpersonnel_etc.personnel_etc_rang"
                            label="วิทยฐานะ"
                          ></v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                          class="pa-1"
                          v-if="
                            editpersonnel_etc.personnel_etc_m_type ===
                              'government'
                          "
                        >
                          <v-text-field
                            outlined
                            v-model="editpersonnel_etc.personnel_etc_type"
                            label="ประเภท"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                          class="pa-1"
                          v-if="
                            editpersonnel_etc.personnel_etc_m_type ===
                              'government'
                          "
                        >
                          <v-text-field
                            outlined
                            v-model="editpersonnel_etc.personnel_etc_about"
                            label="ด้าน"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                          class="pa-1"
                          v-if="
                            isTemporary(editpersonnel_etc.personnel_etc_m_type)
                          "
                        >
                          <v-select
                            outlined
                            v-model="editpersonnel_etc.personnel_etc_safety"
                            label="ประกันสังคม"
                            :items="safety"
                            item-text="text"
                            item-value="value"
                          ></v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                          class="pa-1"
                          v-if="
                            isTemporary(editpersonnel_etc.personnel_etc_m_type)
                          "
                        >
                          <v-select
                            outlined
                            v-model="editpersonnel_etc.personnel_etc_budget"
                            label="งบประมาณ"
                            :items="budget_etcs"
                            item-text="budget_etcdetail"
                            item-value="budget_etcid"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" md="3" class="pa-1">
                          <v-text-field
                            outlined
                            v-model="editpersonnel_etc.personnel_etc_salary"
                            label="อัตราเงินเดือน"
                            type="number"
                          ></v-text-field>
                        </v-col>

                        <!-- ===== ประเภทวิชา/สาขาวิชา (สายการสอน) ===== -->
                        <template
                          v-if="
                            isTeachingTypeOrGovSP(
                              editpersonnel_etc.personnel_etc_m_type
                            )
                          "
                        >
                          <v-col cols="12"><hr /></v-col>
                          <v-col cols="12">
                            <div class="font-weight-bold">
                              <v-icon>mdi-book-open-variant</v-icon
                              >ข้อมูลสาขาวิชาและชั่วโมงสอน
                            </div>

                            <!-- แจ้งเตือนรอบรายงานใน Dialog แก้ไข -->
                            <v-alert
                              v-if="activeRound && activeRound.round_id"
                              dense
                              outlined
                              type="info"
                              class="mt-2"
                            >
                              <strong>รอบรายงานที่เปิดอยู่:</strong>
                              {{ activeRound.round_name }}
                              — กรุณากรอก{{ activeRoundTeachSemesterLabel }}
                            </v-alert>
                          </v-col>
                          <v-col cols="12" md="4" class="pa-1">
                            <v-autocomplete
                              outlined
                              v-model="editpersonnel_etc.personnel_etc_subject"
                              :items="subject_types"
                              item-text="subject_typeName"
                              item-value="subject_typeID"
                              label="ประเภทวิชา"
                              @change="onSubjectChangeEdit()"
                            >
                              <template v-slot:item="{ item }">
                                <div>
                                  <div style="font-weight: bold;">
                                    {{ item.subject_typeID }} :
                                    {{ item.subject_typeName }}
                                  </div>
                                </div>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="4" class="pa-1">
                            <v-autocomplete
                              outlined
                              dense
                              hide-details="auto"
                              v-model="editpersonnel_etc.personnel_etc_branch"
                              :items="rate_work_course_stds"
                              :item-text="
                                editpersonnel_etc.personnel_etc_subject === '66'
                                  ? 'short_courseSTBranch'
                                  : 'branch_name_th'
                              "
                              :item-value="
                                editpersonnel_etc.personnel_etc_subject === '66'
                                  ? 'short_courseSTBranchID'
                                  : 'id_course_branch'
                              "
                              label="2. สาขาวิชา"
                              prepend-inner-icon="mdi-numeric-2-circle"
                              :disabled="
                                !editpersonnel_etc.personnel_etc_subject
                              "
                              :hint="
                                !editpersonnel_etc.personnel_etc_subject
                                  ? 'เลือกประเภทวิชาก่อน'
                                  : ''
                              "
                              persistent-hint
                              @change="onBranchChangeEdit()"
                            >
                              <template v-slot:item="{ item }">
                                <div class="py-1" style="max-width:400px">
                                  <div
                                    class="font-weight-bold"
                                    style="color:#1565c0"
                                  >
                                    <v-icon x-small color="primary" class="mr-1"
                                      >mdi-book-open-variant</v-icon
                                    >
                                    <span
                                      v-if="
                                        editpersonnel_etc.personnel_etc_subject ===
                                          '66'
                                      "
                                    >
                                      {{ item.short_courseSTBranchID }} :
                                      {{ item.short_courseSTBranch }}
                                    </span>
                                    <span v-else>
                                      <span
                                        v-if="item.rate_work_level_class === 20"
                                        >ปวช.</span
                                      >
                                      <span
                                        v-else-if="
                                          item.rate_work_level_class === 30
                                        "
                                        >ปวส.</span
                                      >
                                      <span
                                        v-else-if="
                                          item.rate_work_level_class === 40
                                        "
                                        >ปวส.</span
                                      >
                                      <span v-else>-</span>
                                      {{ item.branch_name_th }}</span
                                    >
                                  </div>
                                  <div class="caption grey--text ml-5">
                                    <span
                                      v-if="
                                        editpersonnel_etc.personnel_etc_subject ===
                                          '66'
                                      "
                                    >
                                      กลุ่ม: {{ item.short_courseGroupName }}
                                    </span>
                                    <span v-else>
                                      ปี {{ item.year_course }} | ประเภทวิชา:
                                      {{ item.type_course }}
                                    </span>
                                  </div>
                                </div>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="4" class="pa-1">
                            <v-autocomplete
                              outlined
                              dense
                              hide-details="auto"
                              v-model="
                                editpersonnel_etc.personnel_etc_branch_sub
                              "
                              :items="rate_work_course_stdSubs"
                              :item-text="
                                editpersonnel_etc.personnel_etc_subject === '66'
                                  ? 'short_courseName'
                                  : 'branch_sub_name_th'
                              "
                              :item-value="
                                editpersonnel_etc.personnel_etc_subject === '66'
                                  ? 'short_courseID'
                                  : 'id_course_branch_sub'
                              "
                              label="3. สาขางาน"
                              prepend-inner-icon="mdi-numeric-3-circle"
                              :disabled="
                                !editpersonnel_etc.personnel_etc_branch
                              "
                              :hint="
                                !editpersonnel_etc.personnel_etc_branch
                                  ? 'เลือกสาขาวิชาก่อน'
                                  : ''
                              "
                              persistent-hint
                            >
                            </v-autocomplete>
                          </v-col>

                          <!-- ===== ชั่วโมงสอน ===== -->
                          <v-col
                            cols="12"
                            md="3"
                            class="pa-1"
                            v-if="
                              isTeachingType(
                                editpersonnel_etc.personnel_etc_m_type
                              )
                            "
                          >
                            <v-text-field
                              outlined
                              v-model="
                                editpersonnel_etc.personnel_etc_teach_year
                              "
                              label="ปีการศึกษา"
                              placeholder="เช่น 2568"
                              maxlength="4"
                              type="number"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            md="3"
                            class="pa-1"
                            v-if="
                              isTeachingType(
                                editpersonnel_etc.personnel_etc_m_type
                              )
                            "
                          >
                            <v-text-field
                              outlined
                              v-model="
                                editpersonnel_etc.personnel_etc_teach_hours_s1
                              "
                              label="ชั่วโมงสอน/สัปดาห์ (ภาคเรียนที่ 1)"
                              type="number"
                              min="0"
                              max="40"
                              hint="จำนวนชั่วโมงสอนต่อสัปดาห์"
                              persistent-hint
                              :background-color="
                                activeRoundTeachSemester === 1 ? '#FFF8E1' : ''
                              "
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            md="3"
                            class="pa-1"
                            v-if="
                              isTeachingType(
                                editpersonnel_etc.personnel_etc_m_type
                              )
                            "
                          >
                            <v-text-field
                              outlined
                              v-model="
                                editpersonnel_etc.personnel_etc_teach_hours_s2
                              "
                              label="ชั่วโมงสอน/สัปดาห์ (ภาคเรียนที่ 2)"
                              type="number"
                              min="0"
                              max="40"
                              hint="จำนวนชั่วโมงสอนต่อสัปดาห์"
                              persistent-hint
                              :background-color="
                                activeRoundTeachSemester === 2 ? '#FFF8E1' : ''
                              "
                            ></v-text-field>
                          </v-col>
                        </template>

                        <v-col cols="12"><hr /></v-col>

                        <!-- ข้อมูลด้านการศึกษา -->
                        <v-col cols="12">
                          <div class="font-weight-bold">
                            <v-icon>mdi-school</v-icon>ข้อมูลด้านการศึกษา
                          </div>
                        </v-col>
                        <v-col cols="12" class="pa-1">
                          <personnel_education
                            v-if="
                              String(editpersonnel_etc.personnel_etc_id_card)
                                .length > 11
                            "
                            :editpersonnel_temporary="editpersonnel_etc"
                          />
                        </v-col>

                        <v-col cols="12"><hr /></v-col>

                        <!-- ข้อมูลช่วยราชการ -->
                        <v-col cols="12">
                          <div class="font-weight-bold">
                            <v-icon color="orange"
                              >mdi-swap-horizontal-bold</v-icon
                            >ข้อมูลช่วยราชการ
                          </div>
                        </v-col>
                        <v-col cols="12" md="4" class="pa-1">
                          <v-select
                            outlined
                            v-model="
                              editpersonnel_etc.personnel_etc_help_status
                            "
                            :items="helpStatusOptions"
                            item-text="text"
                            item-value="value"
                            label="สถานะช่วยราชการ"
                            clearable
                          ></v-select>
                        </v-col>
                        <v-col cols="12" md="4" class="pa-1">
                          <v-autocomplete
                            outlined
                            v-model="
                              editpersonnel_etc.personnel_etc_help_college_code
                            "
                            :items="allColleges"
                            item-text="user_firstname"
                            item-value="user_code"
                            label="วิทยาลัยที่ช่วยราชการ"
                            clearable
                            :disabled="
                              !editpersonnel_etc.personnel_etc_help_status
                            "
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="4" class="pa-1">
                          <v-menu
                            v-model="menuHelpDate"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                outlined
                                v-model="
                                  editpersonnel_etc.personnel_etc_help_date
                                "
                                label="วันที่เริ่มช่วยราชการ"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                clearable
                                :disabled="
                                  !editpersonnel_etc.personnel_etc_help_status
                                "
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="
                                editpersonnel_etc.personnel_etc_help_date
                              "
                              @input="menuHelpDate = false"
                              locale="th"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-text class="red--text">
              * หากหมายเลขบัตรประชาชนผิดจากการกรอกข้อมูลของสถานศึกษา
              ให้ดำเนินการลบรายการ และเพิ่มข้อมูลใหม่
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click.stop="editpersonnel_etcdialog = false" rounded>
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                color="warning"
                @click.stop="editpersonnel_etcSubmit()"
                rounded
              >
                <v-icon dark>mdi-pencil</v-icon>&nbsp;แก้ไขข้อมูล
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- Dialog: นำเข้า CSV -->
      <v-layout>
        <v-dialog v-model="personnel_etcCSVdialog" persistent max-width="60%">
          <v-card class="mx-auto pa-5">
            <base-material-card
              color="green"
              icon="mdi-content-paste"
              title="นำเข้าข้อมูลบุคลากร"
              class="px-5 py-3"
            ></base-material-card>
            <v-card-text>
              <v-card>
                <v-card-text>
                  <v-form ref="personnel_etcCSVdialogform" lazy-validation>
                    <v-container grid-list-md>
                      <v-row>
                        <v-col cols="12">
                          <v-btn
                            outlined
                            block
                            color="info"
                            :to="
                              '/college/personnel_etc_import/' + user.user_code
                            "
                            target="_blank"
                          >
                            <v-icon>mdi-exit-to-app</v-icon
                            >ส่งออกแบบฟอร์มบันทึกข้อมูล
                          </v-btn>
                        </v-col>
                        <v-col cols="12">
                          <v-file-input
                            v-model="file2"
                            accept=".csv"
                            name="csvFiles"
                            color="deep-purple accent-4"
                            counter
                            label="ไฟล์ .csv กรุณา Save as Type: CSV UTF-8 (Comma delimited)"
                            placeholder="ไฟล์ CSV ข้อมูลบุคลากร"
                            prepend-icon="mdi-paperclip"
                            outlined
                            rounded
                            :show-size="1000"
                            :rules="[v => !!v || '']"
                          ></v-file-input>
                          <div class="red--text ma-5 text-center">
                            กรุณาตรวจสอบฟิลล์ รหัสบัตรประชาชน ให้อยู่ในรูปแบบ
                            Custom Type : 0
                          </div>
                          <v-btn
                            class="pa-2"
                            block
                            color="green"
                            @click.stop="csvpersonnel_etcSubmit()"
                          >
                            <v-icon>mdi-book-plus</v-icon>นำเข้า
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-card-text>
            <v-row>
              <v-col cols="12" class="text-right">
                <v-btn
                  class="mx-2"
                  fab
                  dark
                  color="grey"
                  @click.stop="personnel_etcCSVdialog = false"
                >
                  <v-icon dark>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- Video Dialog -->
      <v-layout>
        <v-dialog
          v-model="VideoDialogYoutubeConditionbranch"
          persistent
          max-width="80%"
        >
          <v-card class="pa-0">
            <iframe
              width="100%"
              height="600px"
              src="https://www.youtube.com/embed/AGr0Gx0hxME"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                rounded
                @click.stop="VideoDialogYoutubeConditionbranch = false"
              >
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>

    <v-container fluid>
      <v-snackbar
        v-model="snackbar.show"
        multi-line
        vertical
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        <v-icon>{{ snackbar.icon }}</v-icon
        ><br />
        {{ snackbar.text }}
        <v-btn dark @click="snackbar.show = false">Close</v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Personnel_report from "../../components/college/personnel_report.vue";
import personnel_education from "../../components/college/personnel_education.vue";
export default {
  name: "personnel_etc_college",
  components: { Personnel_report, personnel_education },
  data() {
    return {
      ApiKey: "HRvec2021",
      loading: false,
      search: "",
      searchIDcard: "",
      // ตัวกรอง
      filterType: null,
      filterHelpStatus: null,
      filterTypeOptions: [
        { text: "ข้าราชการครู", value: "teacher" },
        { text: "รองผู้อำนวยการ", value: "se_director" },
        { text: "ผู้อำนวยการ", value: "director" },
        { text: "38 ค.(2)", value: "38" },
        { text: "ลูกจ้างประจำ", value: "permanent" },
        { text: "พนักงานราชการ(สายการสอน)", value: "governmentteach" },
        { text: "พนักงานราชการ(สายสนับสนุน)", value: "governmentsp" },
        { text: "ครูอัตราจ้าง", value: "temporary" },
        { text: "ลูกจ้างชั่วคราว", value: "temporary_job" }
      ],
      filterHelpOptions: [
        { text: "ไปช่วยราชการ", value: "helping" },
        { text: "รับช่วยราชการ", value: "receiving" },
        { text: "ปกติ (ไม่ช่วยราชการ)", value: "normal" }
      ],
      // ===== รอบรายงาน (ใหม่) =====
      activeRound: {},
      // Dialogs
      addpersonnel_etcdialog: false,
      editpersonnel_etcdialog: false,
      deletepersonnel_etcdialog: false,
      searchPersonnel_etcdialog: false,
      personnel_etcCSVdialog: false,
      VideoDialogYoutubeConditionbranch: false,
      menuHelpDate: false,
      snackbar: { show: false, color: "", timeout: 5000, icon: "", text: "" },
      headers: [],
      selectedHeaders: [],
      headersMap: [
        { text: "ประเภท", value: "personnel_etc_m_type" },
        { text: "แก้ไข", value: "actions" },
        { text: "ลบ", value: "action_s" },
        { text: "ID PLAN", value: "personnel_etc_idplan" },
        { text: "Reset Password", value: "reset" },
        { text: "สถานะช่วยราชการ", value: "personnel_etc_help_status" },
        { text: "วิทยาลัยที่ช่วย", value: "collegeHelpname" },
        { text: "รหัส", value: "personnel_etc_id_card" },
        { text: "คำนำหน้าชื่อ", value: "personnel_etc_title" },
        { text: "ชื่อ", value: "personnel_etc_fristname" },
        { text: "นามสกุล", value: "personnel_etc_lastname" },
        { text: "ภารกิจ/งาน", value: "personnel_etc_workgroup" },
        { text: "เลขที่ตำแหน่ง", value: "personnel_etc_id_position" },
        { text: "อันดับ/ระดับ", value: "personnel_etc_level" },
        { text: "วิทยฐานะ", value: "personnel_etc_rang" },
        { text: "วุฒิการศึกษา", value: "education_summary", sortable: false },
        { text: "ประเภท", value: "personnel_etc_type" },
        { text: "ด้าน", value: "personnel_etc_about" },
        { text: "ประกันสังคม", value: "personnel_etc_safety" },
        { text: "งบประมาณ", value: "budget_etcdetail" },
        { text: "เงินเดือน", value: "personnel_etc_salary" },
        { text: "ชม.สอน ภ.1", value: "personnel_etc_teach_hours_s1" },
        { text: "ชม.สอน ภ.2", value: "personnel_etc_teach_hours_s2" },
        { text: "ประเภทวิชา", value: "personnel_etc_subject" },
        { text: "ปีหลักสูตร", value: "year_course" },
        { text: "สาขาวิชา", value: "personnel_etc_branch_n" },
        { text: "สาขาวิชางาน", value: "personnel_etc_branch_Subn" }
      ],
      personnel_etcs: [],
      expanded: [],
      educationMap: {}, // { id_card: [ {education rows...} ] }
      addpersonnel_etc: {},
      editpersonnel_etc: [],
      personnel_etcsCounts: [],
      personnel_temporarys: [],
      searchadd_temporary: {},
      user: [],
      workgroups: [],
      subject_types: [],
      personnel_etcSYSs: [],
      addpersonnel_req: {},
      personnel_reqReqNTB: [],
      personnel_reqReqOTB: [],
      personnel_reqHearder: [
        { text: "ชื่อ-นามสกุล", value: "personel_reqIDcard" },
        { text: "สังกัดเดิม", value: "oldCollege" },
        { text: "วันที่ข้อมูล", value: "personel_reqDate" },
        { text: "สถานะ", value: "personel_reqStatus" },
        { text: "ยกเลิก", value: "action" }
      ],
      personnel_reqOHearder: [
        { text: "ชื่อ-นามสกุล", value: "personel_reqIDcard" },
        { text: "สังกัดใหม่", value: "newCollege" },
        { text: "วันที่ข้อมูล", value: "personel_reqDate" },
        { text: "สถานะ", value: "personel_reqStatus" }
      ],
      validateInputcheck: [],
      rate_work_course_stds: [],
      rate_work_course_stdSubs: [],
      prefixs: [],
      budget_etcs: [],
      file2: null,
      data_syslog: {},
      personnel_etcreset: {},
      allColleges: [],
      helpStatusOptions: [
        { text: "ไปช่วยราชการ", value: "helping" },
        { text: "-", value: "-" }
      ],
      typeNationality: [
        { text: "สัญชาติไทย", value: "0" },
        { text: "สัญชาติอื่นๆ", value: "1" }
      ],
      type_personnelGov: [
        { text: "ครู", value: "teacher" },
        { text: "รองผู้อำนวยการ", value: "se_director" },
        { text: "ผู้อำนวยการ", value: "director" },
        { text: "38 ค.(2)", value: "38" },
        { text: "พนักงานราชการ(สายการสอน)", value: "governmentteach" },
        { text: "พนักงานราชการ(สายสนับสนุน)", value: "governmentsp" }
      ],
      type_personnel: [
        { text: "ครู", value: "teacher" },
        { text: "รองผู้อำนวยการ", value: "se_director" },
        { text: "ผู้อำนวยการ", value: "director" },
        { text: "38 ค.(2)", value: "38" },
        { text: "ลูกจ้างประจำ", value: "permanent" },
        { text: "พนักงานราชการ(สายการสอน)", value: "governmentteach" },
        { text: "พนักงานราชการ(สายสนับสนุน)", value: "governmentsp" },
        { text: "ครูอัตราจ้าง", value: "temporary" },
        { text: "ลูกจ้างชั่วคราว", value: "temporary_job" }
      ],
      rang_names: [
        { text: "ต้น", value: "ต้น" },
        { text: "ปฏิบัติงาน", value: "ปฏิบัติงาน" },
        { text: "ปฏิบัติการ", value: "ปฏิบัติการ" },
        { text: "ครูผู้ช่วย", value: "ครูผู้ช่วย" },
        { text: "ครู", value: "ครู" },
        { text: "ชำนาญงาน", value: "ชำนาญงาน" },
        { text: "ชำนาญการ", value: "ชำนาญการ" },
        { text: "ชำนาญการพิเศษ", value: "ชำนาญการพิเศษ" },
        { text: "เชี่ยวชาญ", value: "เชี่ยวชาญ" },
        { text: "เชี่ยวชาญพิเศษ", value: "เชี่ยวชาญพิเศษ" }
      ],
      rang_levels: [
        { text: "ครูผู้ช่วย", value: "ครูผู้ช่วย" },
        { text: "1", value: "1" },
        { text: "2", value: "2" },
        { text: "3", value: "3" },
        { text: "4", value: "4" },
        { text: "5", value: "5" }
      ],
      safety: [
        { text: "มาตรา 33", value: "มาตรา 33" },
        { text: "มาตรา 40", value: "มาตรา 40" },
        { text: "ไม่มีประกันสังคม", value: "ไม่มีประกันสังคม" }
      ],
      personnelTypeMap: {
        permanent: { label: "ลูกจ้างประจำ", class: "warning--text" },
        governmentteach: {
          label: "พนักงานราชการ(สายการสอน)",
          class: "warning--text"
        },
        governmentsp: {
          label: "พนักงานราชการ(สายสนับสนุน)",
          class: "warning--text"
        },
        temporary: { label: "ครูอัตราจ้าง", class: "purple--text" },
        temporary_job: { label: "ลูกจ้างชั่วคราว", class: "purple--text" },
        teacher: { label: "ข้าราชการครู", class: "primary--text" },
        se_director: { label: "รองผู้อำนวยการ", class: "info--text" },
        director: { label: "ผู้อำนวยการ", class: "info--text" },
        "38": { label: "38 ค. (2)", class: "primary--text" }
      }
    };
  },

  computed: {
    showHeaders() {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    },
    color() {
      return "brown-darken-4";
    },
    date_today_log() {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yyyy = today.getFullYear() + 543;
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      return dd + "/" + mm + "/" + yyyy + "/" + time;
    },
    idCardRulesAdd() {
      return [
        v => !!v || "This field is required",
        v => (!!v && v.length == 13) || "13 ID Card",
        this.validateInputcheck === "true" || "กำหนดรหัสบัตรประชาชนไม่ถูกต้อง"
      ];
    },

    // ===== ตัวกรองข้อมูลตาราง =====
    filteredPersonnelEtcs() {
      let data = this.personnel_etcs;
      if (this.filterType) {
        data = data.filter(p => p.personnel_etc_m_type === this.filterType);
      }
      if (this.filterHelpStatus) {
        if (this.filterHelpStatus === "normal") {
          data = data.filter(
            p =>
              !p.personnel_etc_help_status ||
              p.personnel_etc_help_status === "-"
          );
        } else {
          data = data.filter(
            p => p.personnel_etc_help_status === this.filterHelpStatus
          );
        }
      }
      return data;
    },

    // ===== สถิติ Dashboard =====
    statCards() {
      const c = this.personnel_etcsCounts;
      return [
        {
          label: "รวมทั้งหมด",
          count: c.sumAll || 0,
          icon: "mdi-account-group",
          color: "primary"
        },
        {
          label: "ข้าราชการ/ผู้บริหาร",
          count:
            parseInt(c.directors || 0) +
            parseInt(c.se_directors || 0) +
            parseInt(c.teachers || 0),
          icon: "mdi-shield-account",
          color: "indigo"
        },
        {
          label: "พนักงานราชการ",
          count:
            parseInt(c.governmentteach || 0) + parseInt(c.governmentsp || 0),
          icon: "mdi-badge-account",
          color: "teal"
        },
        {
          label: "อัตราจ้าง/ลูกจ้าง",
          count:
            parseInt(c.temporarys || 0) +
            parseInt(c.temporary_jobs || 0) +
            parseInt(c.permanents || 0),
          icon: "mdi-account-hard-hat",
          color: "deep-orange"
        }
      ];
    },

    teachingHoursStats() {
      const teachers = this.personnel_etcs.filter(p =>
        this.isTeachingType(p.personnel_etc_m_type)
      );
      const totalTeachers = teachers.length;
      if (totalTeachers === 0) return { avgS1: 0, avgS2: 0, totalTeachers: 0 };

      const sumS1 = teachers.reduce(
        (s, p) => s + (parseInt(p.personnel_etc_teach_hours_s1) || 0),
        0
      );
      const sumS2 = teachers.reduce(
        (s, p) => s + (parseInt(p.personnel_etc_teach_hours_s2) || 0),
        0
      );
      const teachersWithHours =
        teachers.filter(
          p => p.personnel_etc_teach_hours_s1 || p.personnel_etc_teach_hours_s2
        ).length || 1;

      return {
        avgS1: Math.round(sumS1 / teachersWithHours),
        avgS2: Math.round(sumS2 / teachersWithHours),
        totalTeachers
      };
    },

    helpingCount() {
      return this.personnel_etcs.filter(
        p =>
          p.personnel_etc_help_status === "helping" ||
          p.personnel_etc_help_status === "receiving"
      ).length;
    },

    // ============================================================
    // รอบรายงาน → กำหนดภาคเรียนที่ต้องรายงานชั่วโมงสอน (ใหม่)
    // ============================================================
    // ตรรกะ:
    //   round_number = 3 (พฤษภาคม) → รายงาน ภาคเรียนที่ 1
    //   round_number = 1 (ตุลาคม)  → รายงาน ภาคเรียนที่ 2
    //   round_number อื่น          → null (ไม่มีการรายงานชั่วโมงสอนในรอบนี้)
    activeRoundTeachSemester() {
      if (!this.activeRound || !this.activeRound.round_id) return null;
      const rn = parseInt(this.activeRound.round_number);
      if (rn === 3) return 1; // รอบ 3 (พฤษภาคม) → ภาคเรียนที่ 1
      if (rn === 1) return 2; // รอบ 1 (ตุลาคม)  → ภาคเรียนที่ 2
      return null;
    },

    activeRoundTeachSemesterLabel() {
      const sem = this.activeRoundTeachSemester;
      if (sem === 1) return "ชั่วโมงสอน ภาคเรียนที่ 1";
      if (sem === 2) return "ชั่วโมงสอน ภาคเรียนที่ 2";
      return "";
    },

    activeRoundAlertColor() {
      if (!this.activeRound || this.activeRound.round_status !== "open")
        return "grey";
      return "info";
    },

    activeRoundAlertType() {
      if (!this.activeRound || this.activeRound.round_status !== "open")
        return "info";
      return "warning";
    },

    // นับจำนวนสายการสอนที่ยังไม่กรอกชั่วโมงสอนตามรอบ
    teachHoursMissingCount() {
      const sem = this.activeRoundTeachSemester;
      if (!sem) return 0;
      const teachers = this.personnel_etcs.filter(p =>
        this.isTeachingType(p.personnel_etc_m_type)
      );
      const field =
        sem === 1
          ? "personnel_etc_teach_hours_s1"
          : "personnel_etc_teach_hours_s2";
      return teachers.filter(p => !p[field] || parseInt(p[field]) === 0).length;
    },

    // ============================================================
    // ปีหลักสูตร < 2567 — หาบุคลากรที่ต้องปรับปรุง (ใหม่) และ personnel_etc_subject ไม่เท่ากับ '66' ระยะสั้น
    // ============================================================
    outdatedCourseYearPersonnel() {
      // personnel_etc_subject ไม่เท่ากับ '66' ระยะสั้น
      return this.personnel_etcs.filter(p => {
        if (!this.isTeachingType(p.personnel_etc_m_type)) return false;
        if (!p.personnel_etc_subject) return false; // ยังไม่เลือกประเภทวิชา
        if (p.personnel_etc_subject === "66") return false; // ข้ามวิชาระยะสั้น
        const yr = parseInt(p.year_course);
        // ถ้าไม่มี year_course หรือ < 2567 ให้แจ้งเตือน
        return !yr || yr < 2567;
      });
    }
  },

  async created() {
    this.headers = Object.values(this.headersMap);
    this.selectedHeaders = this.headers;
  },

  async mounted() {
    await Promise.all([
      this.workgroupQuery(),
      this.personnel_etcsQueryAll(),
      this.rate_work_course_stdsQueryAll(),
      this.personnel_etcsCount(),
      this.subject_typeQuery(),
      this.prefixQuery(),
      this.budget_etcsQuery(),
      this.allCollegesQuery(),
      this.fetchActiveRound(),
      this.fetchAllEducation()
    ]);

    let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
    let result = await this.$http.post("user.php", {
      ApiKey: this.ApiKey,
      user_ID: userSession.user_ID
    });
    this.user = result.data;

    await this.personnel_reqReqNTBQuery();
    await this.personnel_reqReqOTBQuery();
  },

  methods: {
    // ========================================
    // Helper methods
    // ========================================
    getPersonnelTypeLabel(type) {
      const found = this.personnelTypeMap[type];
      return found ? found.label : "ยังไม่ได้กำหนดประเภท";
    },
    getPersonnelTypeClass(type) {
      const found = this.personnelTypeMap[type];
      return found ? found.class : "red--text";
    },
    getPersonnelTypeChipColor(type) {
      const colors = {
        teacher: "#1565c0",
        se_director: "#00838f",
        director: "#00695c",
        "38": "#4527a0",
        permanent: "#ef6c00",
        governmentteach: "#2e7d32",
        governmentsp: "#558b2f",
        temporary: "#6a1b9a",
        temporary_job: "#ad1457"
      };
      return colors[type] || "#bdbdbd";
    },
    getPersonnelTypeIcon(type) {
      const icons = {
        teacher: "mdi-school",
        se_director: "mdi-account-tie",
        director: "mdi-shield-account",
        "38": "mdi-account-cog",
        permanent: "mdi-account-hard-hat",
        governmentteach: "mdi-teach",
        governmentsp: "mdi-account-wrench",
        temporary: "mdi-account-clock",
        temporary_job: "mdi-account-alert"
      };
      return icons[type] || "mdi-account";
    },
    isTemporary(type) {
      return ["temporary", "temporary_job"].includes(type);
    },
    isTeachingType(type) {
      return ["teacher", "governmentteach", "temporary", "permanent"].includes(type);
    },
    isTeachingTypeOrGovSP(type) {
      return [
        "teacher",
        "governmentteach",
        "governmentsp",
        "temporary",
        "permanent"
      ].includes(type);
    },
    isTeachingTypeByStatus(status) {
      return ["teacher", "governmentteach", "temporary", "permanent"].includes(status);
    },
    isGovernment(type) {
      return ["governmentteach", "governmentsp"].includes(type);
    },
    isGovType(type) {
      return ["teacher", "se_director", "director", "38", "gov_em"].includes(
        type
      );
    },
    isResetAllowed(type) {
      return [
        "permanent",
        "governmentteach",
        "governmentsp",
        "temporary",
        "temporary_job"
      ].includes(type);
    },
    showWorkgroup(type) {
      return ["permanent", "governmentsp", "temporary_job"].includes(type);
    },
    showIdPosition(type) {
      return [
        "permanent",
        "director",
        "se_director",
        "teacher",
        "supervision",
        "governmentteach",
        "governmentsp"
      ].includes(type);
    },
    showRankLevel(type) {
      return [
        "permanent",
        "director",
        "se_director",
        "teacher",
        "supervision"
      ].includes(type);
    },

    // ===== จัดการ workgroup หลายงาน =====
    parseWorkgroups(wgValue) {
      if (!wgValue) return [];
      if (Array.isArray(wgValue)) return wgValue;
      try {
        const parsed = JSON.parse(wgValue);
        return Array.isArray(parsed) ? parsed : [wgValue];
      } catch {
        return [wgValue];
      }
    },

    // ===== วุฒิการศึกษา (personnel_education) =====
    getEducation(idCard) {
      return this.educationMap[idCard] || [];
    },
    // ดึงเฉพาะ "ระดับ" แบบไม่ซ้ำ เรียงจากสูงไปต่ำ เพื่อแสดงเป็น chip สรุป
    educationLevels(idCard) {
      const order = ["ปริญญาเอก", "ปริญญาโท", "ปริญญาตรี", "ต่ำกว่า ป.ตรี"];
      const levels = [
        ...new Set(
          this.getEducation(idCard)
            .map(e => e.education_level)
            .filter(Boolean)
        )
      ];
      return levels.sort((a, b) => order.indexOf(a) - order.indexOf(b));
    },
    eduLevelColor(level) {
      const colors = {
        ปริญญาเอก: "deep-purple",
        ปริญญาโท: "indigo",
        ปริญญาตรี: "blue",
        "ต่ำกว่า ป.ตรี": "blue-grey"
      };
      return colors[level] || "grey";
    },

    // โหลดวุฒิการศึกษาทั้งหมดของวิทยาลัย แล้วจับกลุ่มตาม id_card
    async fetchAllEducation() {
      try {
        let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
        let result = await this.$http.post("personnel_education.php", {
          ApiKey: this.ApiKey,
          personnel_etc_college_code: userSession.user_name,
          group_by_college: "Ok"
        });
        const rows = Array.isArray(result.data) ? result.data : [];
        const map = {};
        rows.forEach(r => {
          const key = r.id_card;
          if (!key) return;
          if (!map[key]) map[key] = [];
          map[key].push(r);
        });
        this.educationMap = map;
      } catch (e) {
        this.educationMap = {};
      }
    },
    getWorkgroupName(wgId) {
      const found = this.workgroups.find(w => w.workGroupID === wgId);
      return found ? found.workGroupName : wgId;
    },

    // ========================================
    // ดึงรอบรายงานที่เปิดอยู่ (ใหม่)
    // ========================================
    async fetchActiveRound() {
      try {
        let result = await this.$http.post("personnel_report_round.php", {
          ApiKey: this.ApiKey,
          action: "get_active_round"
        });
        if (result.data && result.data.round_id) {
          this.activeRound = result.data;
        } else {
          this.activeRound = {};
        }
      } catch (e) {
        this.activeRound = {};
      }
    },

    // ========================================
    // ดึงรายชื่อวิทยาลัยทั้งหมด
    // ========================================
    async allCollegesQuery() {
      try {
        let result = await this.$http.post("user.php", {
          ApiKey: this.ApiKey,
          show_user: "Ok"
        });
        this.allColleges = result.data;
      } catch (e) {
        this.allColleges = [];
      }
    },

    // ========================================
    // ID Card Validation
    // ========================================
    validateInput() {
      const value = this.addpersonnel_etc.personnel_etc_id_card;
      if (!value || value.length !== 13 || !/^[0-9]{13}$/.test(value)) {
        this.validateInputcheck = "false";
        return;
      }
      let sum = 0;
      for (let i = 0; i < 12; i++) {
        sum += parseInt(value.charAt(i)) * (13 - i);
      }
      const check = (11 - (sum % 11)) % 10;
      this.validateInputcheck =
        check === parseInt(value.charAt(12)) ? "true" : "false";
    },

    // ========================================
    // Subject / Branch cascading queries
    // กรองเฉพาะปี 2567 เป็นต้นไป
    // ========================================
    async fetchCoursesBySubject(subjectId) {
      this.rate_work_course_stds = [];
      this.rate_work_course_stdSubs = [];
      if (subjectId === "66") {
        let result = await this.$http.post("short_course.php", {
          ApiKey: this.ApiKey
        });
        this.rate_work_course_stds = result.data;
      } else {
        let data = {
          ApiKey: this.ApiKey,
          id_type_course: subjectId,
          year_course: "2567"
        };
        let result = await this.$http.post("rate_work_course_std.php", data);
        this.rate_work_course_stds = result.data;
      }
    },

    async fetchSubBranch(subjectId, branchId) {
      this.rate_work_course_stdSubs = [];
      if (subjectId === "66") {
        let result = await this.$http.post("short_course.php", {
          ApiKey: this.ApiKey,
          short_courseSTBranchID: branchId
        });
        this.rate_work_course_stdSubs = result.data;
      } else {
        let result = await this.$http.post("rate_work_course_std.php", {
          ApiKey: this.ApiKey,
          id_course_branch: branchId,
          searchGroupID: "Ok"
        });
        this.rate_work_course_stdSubs = result.data;
      }
    },

    onSubjectChangeAdd() {
      this.fetchCoursesBySubject(this.addpersonnel_etc.personnel_etc_subject);
    },
    onBranchChangeAdd() {
      this.fetchSubBranch(
        this.addpersonnel_etc.personnel_etc_subject,
        this.addpersonnel_etc.personnel_etc_branch
      );
    },
    onSubjectChangeEdit() {
      this.fetchCoursesBySubject(this.editpersonnel_etc.personnel_etc_subject);
    },
    onBranchChangeEdit() {
      this.fetchSubBranch(
        this.editpersonnel_etc.personnel_etc_subject,
        this.editpersonnel_etc.personnel_etc_branch
      );
    },
    onSubjectChangeSearch() {
      this.fetchCoursesBySubject(this.addpersonnel_etc.personnel_etc_subject);
    },
    onBranchChangeSearch() {
      this.fetchSubBranch(
        this.addpersonnel_etc.personnel_etc_subject,
        this.addpersonnel_etc.personnel_etc_branch
      );
    },

    // ========================================
    // Data queries
    // ========================================
    async workgroupQuery() {
      let result = await this.$http.post("workgroup.php", {
        ApiKey: this.ApiKey
      });
      this.workgroups = result.data;
    },
    async subject_typeQuery() {
      let result = await this.$http.post("subject_type.php", {
        ApiKey: this.ApiKey
      });
      this.subject_types = result.data;
    },
    async prefixQuery() {
      let result = await this.$http.post("prefix.php", { ApiKey: this.ApiKey });
      this.prefixs = result.data;
    },
    async budget_etcsQuery() {
      let result = await this.$http.post("budget_etc.php", {
        ApiKey: this.ApiKey
      });
      this.budget_etcs = result.data;
    },
    async rate_work_course_stdsQueryAll() {
      let result = await this.$http.post("rate_work_course_std.php", {
        ApiKey: this.ApiKey,
        year_course: "2567"
      });
      this.rate_work_course_stds = result.data;
    },

    async personnel_etcsQueryAll() {
      this.loading = true;
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
      let result = await this.$http
        .post("personnel_etc.php", {
          ApiKey: this.ApiKey,
          personnel_etc_college_code: userSession.user_name
        })
        .finally(() => (this.loading = false));
      this.personnel_etcs = result.data;

      // แปลง workgroup จาก JSON string เป็น array สำหรับแสดงผล
      if (Array.isArray(this.personnel_etcs)) {
        this.personnel_etcs.forEach(p => {
          if (typeof p.personnel_etc_workgroup === "string") {
            try {
              p.personnel_etc_workgroup_parsed = JSON.parse(
                p.personnel_etc_workgroup
              );
            } catch {
              p.personnel_etc_workgroup_parsed = p.personnel_etc_workgroup
                ? [p.personnel_etc_workgroup]
                : [];
            }
          }
        });
      }
    },

    async personnel_etcsCount() {
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
      let result = await this.$http.post("personnel_etc.php", {
        ApiKey: this.ApiKey,
        count_personnel: "Ok",
        personnel_etc_college_code: userSession.user_name
      });
      this.personnel_etcsCounts = result.data;
      let sum = Object.values(this.personnel_etcsCounts).reduce(
        (acc, val) => acc + (parseFloat(val) || 0),
        0
      );
      this.personnel_etcsCounts.sumAll = sum;
    },

    async personnel_etcSearchSYS() {
      let result = await this.$http.post("personnel_etc.php", {
        ApiKey: this.ApiKey,
        personnel_etc_id_card: this.searchIDcard
      });
      this.personnel_etcSYSs = result.data;
      if (!result.data.personnel_etc_id_card) {
        Swal.fire({
          icon: "warning",
          title: "ไม่พบข้อมูลบุคคลดังกล่าว",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },

    async personnel_temporaryQuery() {
      let result = await this.$http.post("personnel_temporary.php", {
        ApiKey: this.ApiKey,
        id_card: this.addpersonnel_etc.personnel_etc_id_card
      });
      this.personnel_temporarys = result.data;
      if (this.personnel_temporarys.id_card) {
        this.searchPersonnel_etcdialog = true;
      }
    },

    async personnel_reqReqNTBQuery() {
      let result = await this.$http.post("personnel_req.php", {
        ApiKey: this.ApiKey,
        personel_reqNewCollege: this.user.user_code
      });
      this.personnel_reqReqNTB = result.data;
    },

    async personnel_reqReqOTBQuery() {
      let result = await this.$http.post("personnel_req.php", {
        ApiKey: this.ApiKey,
        personel_reqOldCollege: this.user.user_code
      });
      this.personnel_reqReqOTB = result.data;
    },

    // ========================================
    // Syslog helper
    // ========================================
    async writeSyslog(eventLog, tableLog, detailLog) {
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
      this.data_syslog.ApiKey = this.ApiKey;
      this.data_syslog.user_account = userSession.user_name;
      this.data_syslog.event_log = eventLog;
      this.data_syslog.page_log = "personnel_etc";
      this.data_syslog.table_log = tableLog;
      this.data_syslog.detail_log = detailLog;
      this.data_syslog.date_times = this.date_today_log;
      await this.$http.post("data_syslog.insert.php", this.data_syslog);
    },

    async sweetAlertLoading() {
      Swal.fire({
        title: "Please Wait !",
        timerProgressBar: true,
        didOpen: () => Swal.showLoading(),
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
    },

    // ========================================
    // CRUD operations
    // ========================================
    async personnel_etcReset(personnel_etc_id_card) {
      const result = await Swal.fire({
        title: "Reset Password",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      });
      if (!result.isConfirmed) return;

      let res = await this.$http.post("personnel_etc.update.pass.php", {
        ApiKey: this.ApiKey,
        personnel_etc_pass: personnel_etc_id_card,
        personnel_etc_id_card: personnel_etc_id_card
      });
      console.log("Reset password response:", res.data);
      if (res.data.status == true || res.data.status == "true") {
        Swal.fire({
          title: "ดำเนินการข้อมูลเรียบร้อย",
          icon: "success",
          showConfirmButton: false,
          timer: 1500
        });
        this.personnel_etcsQueryAll();
        await this.writeSyslog(
          "personnel_etc.update.pass",
          "personnel_etc.update.pass",
          personnel_etc_id_card
        );
      } 
    },
    normalizeWorkgroup(val) {
      if (Array.isArray(val)) return val;
      if (val === null || val === undefined || val === "") return [];
      if (typeof val === "string") {
        try {
          const parsed = JSON.parse(val);
          return Array.isArray(parsed) ? parsed : [parsed];
        } catch {
          return [val];
        }
      }
      return [val]; // number or anything else
    },
    personnel_etcAdd() {
      this.addpersonnel_etc = { personnel_etc_workgroup: [] };
      this.addpersonnel_etcdialog = true;
      this.workgroupQuery();
    },

    async addpersonnel_etcSubmit() {
      if (!this.$refs.addpersonnel_etcform.validate()) return;
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
      this.addpersonnel_etc.ApiKey = this.ApiKey;
      this.addpersonnel_etc.personnel_etc_college_code = userSession.user_name;

      let result = await this.$http.post(
        "personnel_etc.insert.php",
        this.addpersonnel_etc
      );
      if (result.data.status == true) {
        Swal.fire({
          icon: "success",
          title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        this.personnel_etcsQueryAll();
        this.personnel_etcsCount();
        await this.writeSyslog(
          "insert",
          "personnel_etc.insert",
          this.addpersonnel_etc.personnel_etc_id_card
        );
      } else {
        Swal.fire({
          icon: "warning",
          title: "ข้อมูลซ้ำในระบบหรือกรอกข้อมูลไม่ครบ",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.addpersonnel_etcdialog = false;
    },

    async searchPersonnel_etcdialogSubmit() {
      if (!this.$refs.searchPersonnel_etcdialogform.validate()) return;
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;

      this.searchadd_temporary = {
        ApiKey: this.ApiKey,
        personnel_etc_college_code: userSession.user_name,
        personnel_etc_m_type: this.personnel_temporarys.user_status,
        personnel_etc_id_card: this.personnel_temporarys.id_card,
        personnel_etc_title: this.personnel_temporarys.title_s,
        personnel_etc_fristname: this.personnel_temporarys.frist_name,
        personnel_etc_lastname: this.personnel_temporarys.last_name,
        personnel_etc_id_position: this.personnel_temporarys.id_position,
        personnel_etc_level: this.personnel_temporarys.rang_level,
        personnel_etc_rang: this.personnel_temporarys.rang_name,
        personnel_etc_salary: this.personnel_temporarys.salary_s,
        personnel_etc_subject: this.addpersonnel_etc.personnel_etc_subject,
        personnel_etc_branch: this.addpersonnel_etc.personnel_etc_branch,
        personnel_etc_branch_sub: this.addpersonnel_etc.personnel_etc_branch_sub
      };

      let result = await this.$http.post(
        "personnel_etc.insert.php",
        this.searchadd_temporary
      );
      if (result.data.status == true) {
        Swal.fire({
          icon: "success",
          title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        this.personnel_etcsQueryAll();
        this.personnel_etcsCount();
        await this.writeSyslog(
          "insert search",
          "personnel_etc.insert",
          this.searchadd_temporary.personnel_etc_id_card
        );
      } else {
        Swal.fire({
          icon: "warning",
          title: "ดำเนินการผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.addpersonnel_etcdialog = false;
      this.searchPersonnel_etcdialog = false;
    },

    async personnel_etcEdit(personnel_etc_id_card) {
      this.editpersonnel_etc = {};
      let result = await this.$http.post("personnel_etc.php", {
        ApiKey: this.ApiKey,
        personnel_etc_id_card: personnel_etc_id_card
      });
      this.editpersonnel_etc = result.data;

     this.editpersonnel_etc.personnel_etc_workgroup = this.normalizeWorkgroup(
  this.editpersonnel_etc.personnel_etc_workgroup
);

      // ✅ โหลด "สาขาวิชา" ตามประเภทวิชาที่บันทึกไว้ก่อน
      if (this.editpersonnel_etc.personnel_etc_subject) {
        await this.fetchCoursesBySubject(
          this.editpersonnel_etc.personnel_etc_subject
        );
      }
      // ✅ แล้วค่อยโหลด "สาขางาน" ตามสาขาวิชาที่บันทึกไว้
      if (this.editpersonnel_etc.personnel_etc_branch) {
        await this.fetchSubBranch(
          this.editpersonnel_etc.personnel_etc_subject,
          this.editpersonnel_etc.personnel_etc_branch
        );
      }

      this.editpersonnel_etcdialog = true; // เปิดหลังโหลด items เสร็จ
    },

    async editpersonnel_etcSubmit() {
      if (!this.$refs.editpersonnel_etcform.validate()) return;
      this.editpersonnel_etc.ApiKey = this.ApiKey;

      if (!this.editpersonnel_etc.personnel_etc_help_status) {
        this.editpersonnel_etc.personnel_etc_help_college_code = null;
        this.editpersonnel_etc.personnel_etc_help_date = null;
      }

      let result = await this.$http.post(
        "personnel_etc.update.php",
        this.editpersonnel_etc
      );
      if (result.data.status == true) {
        Swal.fire({
          icon: "success",
          title: "แก้ไขข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        this.personnel_etcsQueryAll();
        this.personnel_etcsCount();
        await this.writeSyslog(
          "update",
          "personnel_etc.update",
          this.editpersonnel_etc.personnel_etc_id_card
        );
      } else {
        Swal.fire({
          icon: "warning",
          title: "แก้ไขข้อมูลผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.editpersonnel_etcdialog = false;
    },

    async personnel_etcDelete(personnel_etc_id_card) {
      let result = await this.$http.post("personnel_etc.php", {
        ApiKey: this.ApiKey,
        personnel_etc_id_card: personnel_etc_id_card
      });
      this.editpersonnel_etc = result.data;
      this.deletepersonnel_etcdialog = true;
    },

    async deletepersonnel_etcubmit() {
      if (!this.$refs.deletepersonnel_etcform.validate()) return;
      this.editpersonnel_etc.ApiKey = this.ApiKey;

      let result = await this.$http.post(
        "personnel_etc.delete.php",
        this.editpersonnel_etc
      );
      if (result.data.status == true) {
        Swal.fire({
          icon: "success",
          title: "ลบข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        this.personnel_etcsQueryAll();
        this.personnel_etcsCount();
        await this.writeSyslog(
          "delete",
          "personnel_etc.delete",
          this.editpersonnel_etc.personnel_etc_id_card
        );
      } else {
        Swal.fire({
          icon: "warning",
          title: "ลบข้อมูลผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.deletepersonnel_etcdialog = false;
    },

    async personnel_reqAdd() {
      if (!this.$refs.addpersonnel_reqform.validate()) return;
      this.addpersonnel_req = {
        ApiKey: this.ApiKey,
        personel_reqNewCollege: this.user.user_code,
        personel_reqIDcard: this.personnel_etcSYSs.personnel_etc_id_card,
        personel_reqOldCollege: this.personnel_etcSYSs
          .personnel_etc_college_code,
        personel_reqDate: new Date(),
        personel_reqStatus: "req"
      };

      let result = await this.$http.post(
        "personnel_req.insert.php",
        this.addpersonnel_req
      );
      if (result.data.status == true) {
        Swal.fire({
          icon: "success",
          title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        await this.writeSyslog(
          "insert req",
          "personnel_etc.insert",
          this.addpersonnel_req.personel_reqIDcard
        );
      } else {
        Swal.fire({
          icon: "warning",
          title: "ดำเนินการผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.personnel_etcSYSs = [];
      this.searchIDcard = "";
      this.personnel_reqReqNTBQuery();
    },

    async personnel_reqApprove(personel_reqIDcard) {
      let result = await this.$http.post("personnel_req.php", {
        ApiKey: this.ApiKey,
        personel_reqIDcard: personel_reqIDcard
      });
      const reqData = result.data;
      const personnelApp =
        reqData.personnel_etc_title +
        reqData.personnel_etc_fristname +
        " " +
        reqData.personnel_etc_lastname;

      const confirm = await Swal.fire({
        title: "อนุมัติย้ายข้อมูลบุคคล",
        text: personnelApp,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      });
      if (!confirm.isConfirmed) return;

      await this.sweetAlertLoading();

      let [resultUpdate, resultDel] = await Promise.all([
        this.$http.post("personnel_etc.updateMove.php", {
          ApiKey: this.ApiKey,
          personnel_etc_id_card: reqData.personel_reqIDcard,
          personnel_etc_college_code: reqData.personel_reqNewCollege
        }),
        this.$http.post("personnel_req.delete.php", {
          ApiKey: this.ApiKey,
          personel_reqIDcard: reqData.personel_reqIDcard
        })
      ]);

      if (resultDel.data.status == true && resultUpdate.data.status == true) {
        Swal.fire({
          title: "ดำเนินการข้อมูลเรียบร้อย",
          icon: "success",
          showConfirmButton: false,
          timer: 1500
        });
        this.personnel_etcsQueryAll();
        this.personnel_reqReqNTBQuery();
        this.personnel_reqReqOTBQuery();
        await this.writeSyslog(
          "updateMove req",
          "personnel_etc.updateMove",
          reqData.personel_reqIDcard
        );
      } else {
        Swal.fire({
          icon: "warning",
          title: "ผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
      Swal.close();
    },

    async cancelReg(personel_reqNewCollege, personel_reqIDcard) {
      const confirm = await Swal.fire({
        title: "ยกเลิกรายการร้องขอ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      });
      if (!confirm.isConfirmed) return;

      await this.sweetAlertLoading();
      let resultDel = await this.$http.post(
        "personnel_req.delete.college.php",
        {
          ApiKey: this.ApiKey,
          personel_reqNewCollege: personel_reqNewCollege,
          personel_reqIDcard: personel_reqIDcard
        }
      );

      if (resultDel.data.status == true) {
        Swal.fire({
          title: "ดำเนินการข้อมูลเรียบร้อย",
          icon: "success",
          showConfirmButton: false,
          timer: 1500
        });
        this.personnel_etcsQueryAll();
        this.personnel_reqReqNTBQuery();
        this.personnel_reqReqOTBQuery();
        await this.writeSyslog(
          "personnel_req cancel",
          "personnel_req.delete.college",
          personel_reqIDcard
        );
      } else {
        Swal.fire({
          icon: "warning",
          title: "ผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
      Swal.close();
    },

    async csvpersonnel_etcSubmit() {
      if (!this.file2) return;
      let formData = new FormData();
      let filename = this.user.user_code + ".personnel_etc.csv";
      formData.append("file", this.file2);
      formData.append("filename", "../HRvecfiles/" + filename);
      formData.append("ApiKey", this.ApiKey);

      let result = await this.$http.post("personnel_etcCSV.php", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      if (result.data.status == true) {
        Swal.fire({
          icon: "success",
          title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        await this.writeSyslog("personnel_etc CSV", "personnel_etc.CSV", "CSV");
      } else {
        Swal.fire({
          icon: "warning",
          title: "ดำเนินการผิดพลาด กรุณาตรวจสอบรูปแบบไฟล์",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.personnel_etcsQueryAll();
      this.personnel_etcCSVdialog = false;
    },

    row_classes(item) {
      if (!item.personnel_etc_m_type) return "yellow";
      if (
        !item.personnel_etc_subject &&
        ["teacher", "temporary", "governmentteach"].includes(
          item.personnel_etc_m_type
        )
      ) {
        return "amber";
      }
      // เพิ่ม: ไฮไลท์แถวที่ปีหลักสูตรต่ำกว่า 2567
      if (
        this.isTeachingType(item.personnel_etc_m_type) &&
        item.personnel_etc_subject !== "66"
      ) {
        const yr = parseInt(item.year_course);
        if (!yr || yr < 2567) return "red lighten-5";
      }
    }
  }
};
</script>

<style>
.v-data-table thead th {
  font-size: 14px !important;
  font-weight: 600 !important;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  background: #f5f7ff !important;
  color: #3949ab !important;
  border-bottom: 2px solid #c5cae9 !important;
}
.v-data-table tbody tr:hover {
  background: #f5f7ff !important;
}
.v-data-table tbody tr:nth-child(even) {
  background: #fafbfc;
}
.v-data-table tbody td {
  font-size: 13px !important;
  border-bottom: 1px solid #eef0f5 !important;
}
/* Stat cards animation */
.stat-card-animated {
  transition: all 0.3s ease;
}
.stat-card-animated:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
}
</style>
